import { GameId } from 'src/app/model/game/game-id';
import { ApiResponseActivityFeed } from '../../api/wager-api';
import { ActivityType } from '../../services/activity-feed/models/activity-type';

export type ActivityFeedMock = { status: number; body: ApiResponseActivityFeed };

export const ACTIVITY_FEED_BLOCKS_MOCK: ActivityFeedMock = {
  status: 200,
  body: {
    msg: 'Activity feed',
    status: 200,
    data: {
      serverTime: 1744052140186,
      activities: {
        '2025-04-07T13:00:00': {
          '75e45706f0b25ad8df51e9ae2e379b6dec676c7a915f9daba1a72fee0e8e1c49': {
            createdAt: 1744030855099,
            activityId: '75e45706f0b25ad8df51e9ae2e379b6dec676c7a915f9daba1a72fee0e8e1c49',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 76549,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'kvcibu',
              winnerScore: 77750,
              winnerUserId: 'owaOo9W5A3O1QwMGoxDeBEjvZxf1',
            },
          },
        },
        '2025-04-07T13:06:00': {
          '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16': {
            createdAt: 1744031201542,
            activityId: '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16',
            data: {
              nick: 'Hangula Kriana',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T13:15:00': {
          '56a45062b2620422d6641605ba19a802575915435c02227fa43f724ddfb6791c': {
            createdAt: 1744031739215,
            activityId: '56a45062b2620422d6641605ba19a802575915435c02227fa43f724ddfb6791c',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'mahmut',
              loserScore: 7379,
              loserUserId: 'tjSOeleYIjONuMJ6X65Pavadqf93',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 26025,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:23:00': {
          e4dbc3ab40c1ecab7339cc7c5c35cd48329d91d9cf9a6ee7e4b3434d6773f375: {
            createdAt: 1744032186085,
            activityId: 'e4dbc3ab40c1ecab7339cc7c5c35cd48329d91d9cf9a6ee7e4b3434d6773f375',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'mahmut',
              loserScore: 3068,
              loserUserId: 'tjSOeleYIjONuMJ6X65Pavadqf93',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4514,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:29:00': {
          '2068c6e74b00bd9e0f7f7fd0af9c2b4206c79368d61be5e9f34121e6308b21e1': {
            createdAt: 1744032583811,
            activityId: '2068c6e74b00bd9e0f7f7fd0af9c2b4206c79368d61be5e9f34121e6308b21e1',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'predator818',
              loserScore: 17616,
              loserUserId: 'pTcwQ5KRehMcEhuLHrrM17iGSMC3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'guiensos',
              winnerScore: 129378,
              winnerUserId: 'mBQPskq1DhhhGhRC0FjfrzRyLwe2',
            },
          },
        },
        '2025-04-07T13:31:00': {
          '087272084c636d2f6bc1161dde5ebeae4f5fd4f83979bcbfc9ca4fb4ff0c36cc': {
            createdAt: 1744032692714,
            activityId: '087272084c636d2f6bc1161dde5ebeae4f5fd4f83979bcbfc9ca4fb4ff0c36cc',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'predator818',
              loserScore: 6491,
              loserUserId: 'pTcwQ5KRehMcEhuLHrrM17iGSMC3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 111258,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:46:00': {
          '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1': {
            createdAt: 1744033611203,
            activityId: '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1',
            data: {
              nick: 'cddih',
              type: ActivityType.NewPlayer,
            },
          },
          '47a82f1cfbafbe581fe42ed51a35e965a31050411c17fa8f958d426ca29832c5': {
            createdAt: 1744033612910,
            activityId: '47a82f1cfbafbe581fe42ed51a35e965a31050411c17fa8f958d426ca29832c5',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'mahmut',
              loserScore: 14099,
              loserUserId: 'tjSOeleYIjONuMJ6X65Pavadqf93',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'guiensos',
              winnerScore: 22282,
              winnerUserId: 'mBQPskq1DhhhGhRC0FjfrzRyLwe2',
            },
          },
        },
        '2025-04-07T13:51:00': {
          '11441ae568180b06701980da503579270eaad15317a7f56dc07d99ea4717f373': {
            createdAt: 1744033911815,
            activityId: '11441ae568180b06701980da503579270eaad15317a7f56dc07d99ea4717f373',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'predator818',
              loserScore: 21308,
              loserUserId: 'pTcwQ5KRehMcEhuLHrrM17iGSMC3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'cddih',
              winnerScore: 154549,
              winnerUserId: 't78cTQ1bZicSHnoEFdlTmNfOffl2',
            },
          },
          '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a': {
            createdAt: 1744033878800,
            activityId: '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a',
            data: {
              nick: 'duboybrown',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:01:00': {
          '1c602ef32d87e2debc7cd0957066028b3572be6ac7e8653315f70996a62ce529': {
            createdAt: 1744034465167,
            activityId: '1c602ef32d87e2debc7cd0957066028b3572be6ac7e8653315f70996a62ce529',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Katie',
              loserScore: 22770,
              loserUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Duy Hoang',
              winnerScore: 65694,
              winnerUserId: '4f4082f5-5f50-4286-a857-1c97c33e3e54',
            },
          },
        },
        '2025-04-07T14:02:00': {
          '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9': {
            createdAt: 1744034570441,
            activityId: '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9',
            data: {
              nick: 'daveman2',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:07:00': {
          '8a75a397595a2c7bede165565dc43a6451cdc25ea5b8b1a337acdf1a0c874e66': {
            createdAt: 1744034841210,
            activityId: '8a75a397595a2c7bede165565dc43a6451cdc25ea5b8b1a337acdf1a0c874e66',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Katie',
              loserScore: 20787,
              loserUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Duy Hoang',
              winnerScore: 88312,
              winnerUserId: '4f4082f5-5f50-4286-a857-1c97c33e3e54',
            },
          },
        },
        '2025-04-07T14:15:00': {
          '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10': {
            createdAt: 1744035349453,
            activityId: '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10',
            data: {
              nick: 'batista',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:16:00': {
          ce42a085f68cf6593be1681a5216c2910f418b1ab742e0cf6f3a07574ef3c012: {
            createdAt: 1744035394047,
            activityId: 'ce42a085f68cf6593be1681a5216c2910f418b1ab742e0cf6f3a07574ef3c012',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'player68232',
              loserScore: 4557,
              loserUserId: 'e198e86f-4433-446b-abd0-f7ac38b265d0',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Katie',
              winnerScore: 28827,
              winnerUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
            },
          },
        },
        '2025-04-07T14:21:00': {
          '046b560254ac6ad1ca2381bc94da953f037c1695e6b833aab40fa8e96c9655fc': {
            createdAt: 1744035701273,
            activityId: '046b560254ac6ad1ca2381bc94da953f037c1695e6b833aab40fa8e96c9655fc',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'jasonmramos',
              loserScore: 4017,
              loserUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'John John',
              winnerScore: 38058,
              winnerUserId: 'e9139756-44a5-4806-8782-3736cf221e90',
            },
          },
        },
        '2025-04-07T14:22:00': {
          '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2': {
            createdAt: 1744035743417,
            activityId: '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2',
            data: {
              nick: 'shoulo',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:23:00': {
          '7c0044c1dd99ec7ed1f102317fbaeb43e7f6f7cc778f27ca2bd831ec9576a42e': {
            createdAt: 1744035792277,
            activityId: '7c0044c1dd99ec7ed1f102317fbaeb43e7f6f7cc778f27ca2bd831ec9576a42e',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Katie',
              loserScore: 22917,
              loserUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'batista',
              winnerScore: 26613,
              winnerUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
            },
          },
        },
        '2025-04-07T14:28:00': {
          '82a7a882357d338b8c520e7615813240dcfff6c5902a509065d886acf3f47818': {
            createdAt: 1744036085222,
            activityId: '82a7a882357d338b8c520e7615813240dcfff6c5902a509065d886acf3f47818',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'batista',
              loserScore: 16653,
              loserUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Katie',
              winnerScore: 16984,
              winnerUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
            },
          },
        },
        '2025-04-07T14:31:00': {
          ea9eb2862a9db60a886b661f3bc611dfc0ea67603f3079fabd63c89e7790c222: {
            createdAt: 1744036304253,
            activityId: 'ea9eb2862a9db60a886b661f3bc611dfc0ea67603f3079fabd63c89e7790c222',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'shoulo',
              loserScore: 41796,
              loserUserId: 'OSqysLCbYZMQxvYvxcxAwXM3Qqh2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'batista',
              winnerScore: 103635,
              winnerUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
            },
          },
        },
        '2025-04-07T14:33:00': {
          '7c9aa0dbcd9b5280954608e87cd34ee93f3f0476287feaf0aefdad3d1ff86d7d': {
            createdAt: 1744036399224,
            activityId: '7c9aa0dbcd9b5280954608e87cd34ee93f3f0476287feaf0aefdad3d1ff86d7d',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Katie',
              loserScore: 11970,
              loserUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ing2328',
              winnerScore: 19368,
              winnerUserId: 'lSdrcaRx1dPfy5GDOO9lzmAalm02',
            },
          },
        },
        '2025-04-07T14:35:00': {
          '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717': {
            createdAt: 1744036555664,
            activityId: '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717',
            data: {
              nick: 'Megan Kilburn',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:36:00': {
          '4f8bf757299f8767508b6a9fc55b5454a92cf2e47fb805f32fdd4a411732d054': {
            createdAt: 1744036589277,
            activityId: '4f8bf757299f8767508b6a9fc55b5454a92cf2e47fb805f32fdd4a411732d054',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'lokhin',
              loserScore: 2574,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'shoulo',
              winnerScore: 14371,
              winnerUserId: 'OSqysLCbYZMQxvYvxcxAwXM3Qqh2',
            },
          },
        },
        '2025-04-07T14:37:00': {
          '7fd514244df5829ea0b34a0864bfe1f3316fa9d34fcfba2c305e9d194603192c': {
            createdAt: 1744036672322,
            activityId: '7fd514244df5829ea0b34a0864bfe1f3316fa9d34fcfba2c305e9d194603192c',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'ing2328',
              loserScore: 10441,
              loserUserId: 'lSdrcaRx1dPfy5GDOO9lzmAalm02',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'batista',
              winnerScore: 128306,
              winnerUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
            },
          },
        },
        '2025-04-07T14:38:00': {
          '52ce5a4bed3c606cab9661857b66e5aaa6163b8ec08a82ec4baa828bbd1508a6': {
            createdAt: 1744036713017,
            activityId: '52ce5a4bed3c606cab9661857b66e5aaa6163b8ec08a82ec4baa828bbd1508a6',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Katie',
              loserScore: 13919,
              loserUserId: 'vbeiYxytClOFdnTKBK28l05yP7F3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'batista',
              winnerScore: 32681,
              winnerUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
            },
          },
        },
        '2025-04-07T14:41:00': {
          bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b: {
            createdAt: 1744036860064,
            activityId: 'bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b',
            data: {
              nick: 'subacromial',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:43:00': {
          a1cc5877e0c5aae298d96523d13d9aac80565d17d0b89e6eaedbdc8e9140e509: {
            createdAt: 1744036987223,
            activityId: 'a1cc5877e0c5aae298d96523d13d9aac80565d17d0b89e6eaedbdc8e9140e509',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'subacromial',
              loserScore: 7864,
              loserUserId: 'atmfBAhQ40XyQZUkxoSW6NQZ7tq1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ing2328',
              winnerScore: 10177,
              winnerUserId: 'lSdrcaRx1dPfy5GDOO9lzmAalm02',
            },
          },
        },
        '2025-04-07T14:44:00': {
          '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011': {
            createdAt: 1744037090963,
            activityId: '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011',
            data: {
              nick: 'mason',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:45:00': {
          '2b210886c4cbfa39bd043dd5629b533c65493aa751c5153c2c6a67bbd612d90a': {
            createdAt: 1744037125470,
            activityId: '2b210886c4cbfa39bd043dd5629b533c65493aa751c5153c2c6a67bbd612d90a',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'andris',
              loserScore: 202,
              loserUserId: '539c26a5-eab9-45e9-9171-b8a46459e600',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 13257,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T14:47:00': {
          ce81d113bb3d018bc47bb98fdfe6e2aeab5a74ef1b4bb6f4f483d11b299debd4: {
            createdAt: 1744037221922,
            activityId: 'ce81d113bb3d018bc47bb98fdfe6e2aeab5a74ef1b4bb6f4f483d11b299debd4',
            data: {
              bounty: {
                amount: 5,
                jackpot: false,
              },
              gameId: GameId.Blocks,
              loserNick: 'kamyab',
              loserScore: 15238,
              loserUserId: '7JpyC0X8jtMdl48s2jnHdOD1Lje2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'batista',
              winnerScore: 100855,
              winnerUserId: 'cqcdHaYk2Aa1fPfuNXWu0jGcgfl1',
            },
          },
        },
        '2025-04-07T14:52:00': {
          '07c1cbf6133a3dc8b1f953f351f9e09e01f23bd1185ee201b471f500b5b482c2': {
            createdAt: 1744037520248,
            activityId: '07c1cbf6133a3dc8b1f953f351f9e09e01f23bd1185ee201b471f500b5b482c2',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'ing2328',
              loserScore: 7487,
              loserUserId: 'lSdrcaRx1dPfy5GDOO9lzmAalm02',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 70624,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T14:56:00': {
          a2de7bc375676e77e27bcc60a6754aa8527dc20ec2edb369c81f1fbae79ea054: {
            createdAt: 1744037797738,
            activityId: 'a2de7bc375676e77e27bcc60a6754aa8527dc20ec2edb369c81f1fbae79ea054',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'lokhin',
              loserScore: 8295,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'mason',
              winnerScore: 41503,
              winnerUserId: 'nfVh8zOXBtPprQ2MlwdeqZDdhMD3',
            },
          },
        },
        '2025-04-07T14:59:00': {
          '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87': {
            createdAt: 1744037948962,
            activityId: '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87',
            data: {
              nick: 'popki',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:09:00': {
          '548e508741645cc540fb494600a2d56728eb4feb453a8bbd4ca84ea1d2e9eb27': {
            createdAt: 1744038558021,
            activityId: '548e508741645cc540fb494600a2d56728eb4feb453a8bbd4ca84ea1d2e9eb27',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'yorman calderon',
              loserScore: 2248,
              loserUserId: '31fa8306-55b6-485a-a6cc-6c68036b67d6',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'popki',
              winnerScore: 9013,
              winnerUserId: 'nNz9qL3ru0UrIGlFAJtxAZyeY3r2',
            },
          },
        },
        '2025-04-07T15:11:00': {
          '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa': {
            createdAt: 1744038702679,
            activityId: '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa',
            data: {
              nick: 'Angel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:17:00': {
          '92ad55cd5004abf33ca3f3c01fd6c456b0d600dc1912ff0d4a7c3a153373b86a': {
            createdAt: 1744039047085,
            activityId: '92ad55cd5004abf33ca3f3c01fd6c456b0d600dc1912ff0d4a7c3a153373b86a',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'popki',
              loserScore: 73884,
              loserUserId: 'nNz9qL3ru0UrIGlFAJtxAZyeY3r2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Angel',
              winnerScore: 127702,
              winnerUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
            },
          },
        },
        '2025-04-07T15:20:00': {
          '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7': {
            createdAt: 1744039215491,
            activityId: '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7',
            data: {
              nick: 'fuke your mom Angel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:25:00': {
          '3a1b271a973f546040a4b58e36c67d9abbedb4a7244a90b0c162163fbd6366b8': {
            createdAt: 1744039554010,
            activityId: '3a1b271a973f546040a4b58e36c67d9abbedb4a7244a90b0c162163fbd6366b8',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'fuke yours',
              loserScore: 110016,
              loserUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'fuke your mom Angel',
              winnerScore: 162181,
              winnerUserId: 'wdqAmzer3Ah0jHa0259nAOqYUCt2',
            },
          },
        },
        '2025-04-07T15:44:00': {
          '42e82d673a621789cd597a74f0bfef5fa16360d6a3413a972fc6ba44532220da': {
            createdAt: 1744040663286,
            activityId: '42e82d673a621789cd597a74f0bfef5fa16360d6a3413a972fc6ba44532220da',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Domenico Marando',
              loserScore: 1351,
              loserUserId: '61bd8390-2d36-4962-8da2-248691e1c4b6',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'fuke yours',
              winnerScore: 71588,
              winnerUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
            },
          },
          '96fb284f2f0582142df112efcdcdd3f9194fcea0fc87abb9affafe4a606408de': {
            createdAt: 1744040695985,
            activityId: '96fb284f2f0582142df112efcdcdd3f9194fcea0fc87abb9affafe4a606408de',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'fuke yours',
              loserScore: 28663,
              loserUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 50911,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T16:16:00': {
          c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be: {
            createdAt: 1744042572569,
            activityId: 'c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be',
            data: {
              nick: 'Ma Bloq',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:18:00': {
          '2ab6463c05e444f76211c0579cb8d39d65476f954f1c509d944444485176f66e': {
            createdAt: 1744042703420,
            activityId: '2ab6463c05e444f76211c0579cb8d39d65476f954f1c509d944444485176f66e',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Domenico Marando',
              loserScore: 4524,
              loserUserId: '61bd8390-2d36-4962-8da2-248691e1c4b6',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'fuke yours',
              winnerScore: 9468,
              winnerUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
            },
          },
        },
        '2025-04-07T16:20:00': {
          '036b4252f369a041986489a24b0d743b2c11ffd7afd44d22ef8a360839e396ae': {
            createdAt: 1744042819526,
            activityId: '036b4252f369a041986489a24b0d743b2c11ffd7afd44d22ef8a360839e396ae',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Ma Bloq',
              loserScore: 3230,
              loserUserId: '32a9e8e3-2378-4517-8f4d-3116204c2ad8',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'fuke yours',
              winnerScore: 86044,
              winnerUserId: 'k6lrXD6BokXubi7ytztPo5CZ4493',
            },
          },
        },
        '2025-04-07T16:28:00': {
          '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d': {
            createdAt: 1744043321475,
            activityId: '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d',
            data: {
              nick: 'Loser',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:34:00': {
          '62a1772b8afd38e4723148517778183e791c205fb2fcb1da955eb6222d534f6a': {
            createdAt: 1744043694489,
            activityId: '62a1772b8afd38e4723148517778183e791c205fb2fcb1da955eb6222d534f6a',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 5342,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'caspermoeller89',
              winnerScore: 14091,
              winnerUserId: '395505d0-db37-48cb-b0eb-c8e609434a56',
            },
          },
        },
        '2025-04-07T16:41:00': {
          ffdb75a21edf16b1a47476220196ba3139bcb33dcb2aa001e4ee4b5f52e01895: {
            createdAt: 1744044105511,
            activityId: 'ffdb75a21edf16b1a47476220196ba3139bcb33dcb2aa001e4ee4b5f52e01895',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'caspermoeller89',
              loserScore: 33174,
              loserUserId: '395505d0-db37-48cb-b0eb-c8e609434a56',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Loser',
              winnerScore: 46064,
              winnerUserId: 'z9kHOUcxSnQNOEGHTdEEquKHAkB3',
            },
          },
        },
        '2025-04-07T16:46:00': {
          '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad': {
            createdAt: 1744044363811,
            activityId: '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad',
            data: {
              nick: 'Joining Soon',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:49:00': {
          f56940bf70c3e315e489558cae79b7f894f3bc70a87b29a1830e830231e4d27c: {
            createdAt: 1744044579258,
            activityId: 'f56940bf70c3e315e489558cae79b7f894f3bc70a87b29a1830e830231e4d27c',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Joining Soon',
              loserScore: 1359,
              loserUserId: '7BVkWNDIbMeQTGasiVpFRMeTER53',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 39225,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T16:51:00': {
          '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0': {
            createdAt: 1744044683325,
            activityId: '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0',
            data: {
              nick: 'Colapinto',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:52:00': {
          '0c14d9b87fc555530f5b48d5716a27bf1a95540c325143d60989591572b809c4': {
            createdAt: 1744044756090,
            activityId: '0c14d9b87fc555530f5b48d5716a27bf1a95540c325143d60989591572b809c4',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Colapinto',
              loserScore: 6602,
              loserUserId: 'IsMXSWtXCFQVk2o1lPHiv0Yv8Ht1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Joining Soon',
              winnerScore: 17756,
              winnerUserId: '7BVkWNDIbMeQTGasiVpFRMeTER53',
            },
          },
        },
        '2025-04-07T16:54:00': {
          '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa': {
            createdAt: 1744044888736,
            activityId: '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa',
            data: {
              nick: 'Saturno',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:58:00': {
          '0b6f3deef7998e87278b3d38161f0d1205feffd8f415f7d7219ebce407b29074': {
            createdAt: 1744045082997,
            activityId: '0b6f3deef7998e87278b3d38161f0d1205feffd8f415f7d7219ebce407b29074',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'John John',
              loserScore: 6343,
              loserUserId: 'e9139756-44a5-4806-8782-3736cf221e90',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Saturno',
              winnerScore: 90752,
              winnerUserId: 'teeNArjwjUc2o8nTDzpZ3klD6Rh2',
            },
          },
        },
        '2025-04-07T17:01:00': {
          bbb11b448754bc4692fb562cd7d815d4b7c8e3b6e5e8485e5194fb7d26f65697: {
            createdAt: 1744045286361,
            activityId: 'bbb11b448754bc4692fb562cd7d815d4b7c8e3b6e5e8485e5194fb7d26f65697',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Saturno',
              loserScore: 19637,
              loserUserId: 'teeNArjwjUc2o8nTDzpZ3klD6Rh2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 91802,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T17:03:00': {
          '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559': {
            createdAt: 1744045401226,
            activityId: '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559',
            data: {
              nick: 'bostero topu',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:16:00': {
          '7ce46efd04d4137a43e05bfbe637324fc612706687b7db79650892bb450575a1': {
            createdAt: 1744046178230,
            activityId: '7ce46efd04d4137a43e05bfbe637324fc612706687b7db79650892bb450575a1',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 94126,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bostero topu',
              winnerScore: 104991,
              winnerUserId: 'adw4qC7sF2dkQX7JJzvUfCTMgWb2',
            },
          },
        },
        '2025-04-07T17:21:00': {
          b30356f71e214a6b7604ba636746b8f4849c809177ba3c8b026429a8e70938b4: {
            createdAt: 1744046475042,
            activityId: 'b30356f71e214a6b7604ba636746b8f4849c809177ba3c8b026429a8e70938b4',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 100385,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Bunker',
              winnerScore: 203613,
              winnerUserId: 'Ztj1gSWYbffo0PR8SC4HRCXb4au2',
            },
          },
        },
        '2025-04-07T17:37:00': {
          '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db': {
            createdAt: 1744047464940,
            activityId: '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db',
            data: {
              nick: 'Hakan Temel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:38:00': {
          '457181169ef4eaabd016ea4ca48a604f423ea0693d5fde99f02ff27030a9ad5c': {
            createdAt: 1744047521678,
            activityId: '457181169ef4eaabd016ea4ca48a604f423ea0693d5fde99f02ff27030a9ad5c',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 36773,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Bunker',
              winnerScore: 74968,
              winnerUserId: 'Ztj1gSWYbffo0PR8SC4HRCXb4au2',
            },
          },
        },
        '2025-04-07T17:50:00': {
          '4f85f9938d105f376ba61257cbb06c40f1017999a62d8026739d756f48eaba38': {
            createdAt: 1744048205945,
            activityId: '4f85f9938d105f376ba61257cbb06c40f1017999a62d8026739d756f48eaba38',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'Hakan Temel',
              loserScore: 9245,
              loserUserId: 'c92a620d-4c6d-4157-8fb2-f3f723b0d7ab',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 19409,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T17:56:00': {
          '32a5a97f56a6d750720ae02f2714ff07cb9a23662769a98adb88724eb4178b95': {
            createdAt: 1744048566785,
            activityId: '32a5a97f56a6d750720ae02f2714ff07cb9a23662769a98adb88724eb4178b95',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'godneverdie',
              loserScore: 28865,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Vector',
              winnerScore: 70785,
              winnerUserId: 'btuqIsmz8TaX42tRdumufvkcKaB3',
            },
          },
        },
        '2025-04-07T18:18:00': {
          d00d381befc76365aa556d6c3cbe2538e73a04313b05f1a79ca6ee1095c6c0fc: {
            createdAt: 1744049918020,
            activityId: 'd00d381befc76365aa556d6c3cbe2538e73a04313b05f1a79ca6ee1095c6c0fc',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'lokhin',
              loserScore: 12488,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Hakan Temel',
              winnerScore: 18998,
              winnerUserId: 'c92a620d-4c6d-4157-8fb2-f3f723b0d7ab',
            },
          },
        },
        '2025-04-07T18:40:00': {
          f990eaac7a7746e242378bf4f04137caddaac78643e11ac80a42ba43e938d8e3: {
            createdAt: 1744051255859,
            activityId: 'f990eaac7a7746e242378bf4f04137caddaac78643e11ac80a42ba43e938d8e3',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'taybry22 ',
              loserScore: 76967,
              loserUserId: 'sg930wk3eGZIEXlv1FVhLLoCOP83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Vector',
              winnerScore: 106596,
              winnerUserId: 'btuqIsmz8TaX42tRdumufvkcKaB3',
            },
          },
        },
        '2025-04-07T18:48:00': {
          a682c910ce8c93c801f0b743f92c75d11d9ec810395b088cc4b69a1a96c26267: {
            createdAt: 1744051734653,
            activityId: 'a682c910ce8c93c801f0b743f92c75d11d9ec810395b088cc4b69a1a96c26267',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'schieber',
              loserScore: 79553,
              loserUserId: 'CnUNarICgKSTFx1AkaFNSHBQQBP2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Vector',
              winnerScore: 97647,
              winnerUserId: 'btuqIsmz8TaX42tRdumufvkcKaB3',
            },
          },
        },
        '2025-04-07T18:50:00': {
          dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b: {
            createdAt: 1744051836883,
            activityId: 'dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b',
            data: {
              nick: 'Schneider',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T18:53:00': {
          c4c78ac04d0a9f69df65f13c84c033573e4494a796a75eea864548730eef1351: {
            createdAt: 1744051982920,
            activityId: 'c4c78ac04d0a9f69df65f13c84c033573e4494a796a75eea864548730eef1351',
            data: {
              gameId: GameId.Blocks,
              loserNick: 'BuildingBridges',
              loserScore: 4621,
              loserUserId: 'xHydFazEhUhZ6voYFR6klX2jI573',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Schneider',
              winnerScore: 58647,
              winnerUserId: 'o3Fzb9QPDWdv1xctr9xXDy9sIF73',
            },
          },
        },
      },
    },
  },
};

export const ACTIVITY_FEED_SOLITAIRE_MOCK: ActivityFeedMock = {
  status: 200,
  body: {
    msg: 'Activity feed',
    status: 200,
    data: {
      serverTime: 1744052208283,
      activities: {
        '2025-04-07T12:58:00': {
          cb934e3412149fac447b11c126250157470d6b490c37f3959684714125211bf9: {
            createdAt: 1744030719517,
            activityId: 'cb934e3412149fac447b11c126250157470d6b490c37f3959684714125211bf9',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Farshad Hajinejad',
              loserScore: 4535,
              loserUserId: '9d9d67d7-88c0-4c96-b5d3-03d0d7cea8a8',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'la mente maestra ',
              winnerScore: 6495,
              winnerUserId: 'a9WXetNCuIWQP5ABC8rQoLZ5YOZ2',
            },
          },
        },
        '2025-04-07T12:59:00': {
          f0fb1fd3705e9afba8137f7db1971e85fdbb8e7a19d324e0bdef626006bb598e: {
            createdAt: 1744030785530,
            activityId: 'f0fb1fd3705e9afba8137f7db1971e85fdbb8e7a19d324e0bdef626006bb598e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 100,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'neckfoot',
              winnerScore: 5810,
              winnerUserId: 'f067b3f1-3620-4ea9-ac84-18de42911edf',
            },
          },
        },
        '2025-04-07T13:04:00': {
          '750cfb6be780ac3a8a6a88d160a41b543d62c16f3c781b0a0609d9eadc592e60': {
            createdAt: 1744031065272,
            activityId: '750cfb6be780ac3a8a6a88d160a41b543d62c16f3c781b0a0609d9eadc592e60',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'kylieky',
              loserScore: 3570,
              loserUserId: 'YjPZOYpdJOYEhjQgeNmfORFUjqE3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 5270,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T13:05:00': {
          '43333ed67ae60b9a88af44a91b83889d1b9305a51978d08661de22e9b953b0c1': {
            createdAt: 1744031118661,
            activityId: '43333ed67ae60b9a88af44a91b83889d1b9305a51978d08661de22e9b953b0c1',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'JankBella',
              loserScore: 190,
              loserUserId: 'BDj1hHMAFVXMIvbpp8AmMKTfI4x1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 225,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T13:06:00': {
          '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16': {
            createdAt: 1744031201542,
            activityId: '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16',
            data: {
              nick: 'Hangula Kriana',
              type: ActivityType.NewPlayer,
            },
          },
          '64222d7a021ecef2c5d63fa43dc94101792b1b38bcf50e96df4c8404fdef3c20': {
            createdAt: 1744031163644,
            activityId: '64222d7a021ecef2c5d63fa43dc94101792b1b38bcf50e96df4c8404fdef3c20',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 4115,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wso18',
              winnerScore: 6085,
              winnerUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
            },
          },
        },
        '2025-04-07T13:09:00': {
          b2aa935538e3a732536271266b578307a7206f96fd58f9f8e780e294f7aee6e4: {
            createdAt: 1744031368091,
            activityId: 'b2aa935538e3a732536271266b578307a7206f96fd58f9f8e780e294f7aee6e4',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 280,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'kylieky',
              winnerScore: 2920,
              winnerUserId: 'YjPZOYpdJOYEhjQgeNmfORFUjqE3',
            },
          },
          e00214b88a26ceefd9759b717de05cd3914f4ec051a63266542dc4cf342b0f4f: {
            createdAt: 1744031351038,
            activityId: 'e00214b88a26ceefd9759b717de05cd3914f4ec051a63266542dc4cf342b0f4f',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'neckfoot',
              loserScore: 25,
              loserUserId: 'f067b3f1-3620-4ea9-ac84-18de42911edf',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 300,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T13:15:00': {
          '454dd114b96f66c6b1895d9b5e450d0b3280832a261c457f1bd44c762f51631a': {
            createdAt: 1744031751681,
            activityId: '454dd114b96f66c6b1895d9b5e450d0b3280832a261c457f1bd44c762f51631a',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ryguy',
              loserScore: 0,
              loserUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'kylieky',
              winnerScore: 70,
              winnerUserId: 'YjPZOYpdJOYEhjQgeNmfORFUjqE3',
            },
          },
        },
        '2025-04-07T13:18:00': {
          '375a328e45b31876d41e9dbf41f86ec657022b9480feecb78291098fe239c300': {
            createdAt: 1744031927240,
            activityId: '375a328e45b31876d41e9dbf41f86ec657022b9480feecb78291098fe239c300',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ryguy',
              loserScore: 50,
              loserUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 125,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T13:23:00': {
          c5b3a2ce5ba0057d1b9b9072fd0c6e32560093868970ebe1ebf79c9350c9d3c2: {
            createdAt: 1744032198881,
            activityId: 'c5b3a2ce5ba0057d1b9b9072fd0c6e32560093868970ebe1ebf79c9350c9d3c2',
            data: {
              bounty: {
                amount: 25,
                jackpot: false,
              },
              gameId: GameId.Solitaire,
              loserNick: 'ryguy',
              loserScore: 2700,
              loserUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 5155,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:24:00': {
          '06c8d707684a944c46b2aaaf89a8ea286efe6202b601e25676afa467c40dcc4b': {
            createdAt: 1744032266679,
            activityId: '06c8d707684a944c46b2aaaf89a8ea286efe6202b601e25676afa467c40dcc4b',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'yukselcet',
              loserScore: 3620,
              loserUserId: 'HH3QVer20pSQ3u6YN3ikWipDi2N2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 5745,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:34:00': {
          '6b2b4a2d387725a8911a12d8cb1f28170c08aab3f4d42989ea0d4c3efc8193b0': {
            createdAt: 1744032899220,
            activityId: '6b2b4a2d387725a8911a12d8cb1f28170c08aab3f4d42989ea0d4c3efc8193b0',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'gravesal',
              loserScore: 70,
              loserUserId: '4esF0gzjHUb616OpARJ9pkWMAkw2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Lee Olson',
              winnerScore: 4435,
              winnerUserId: '4dd70a94-645a-498c-9a32-3bec980bac41',
            },
          },
        },
        '2025-04-07T13:38:00': {
          '5e6d869981767bcc0989a5e36f3b314db67f38460506e5929b4a82801f22fe9e': {
            createdAt: 1744033133255,
            activityId: '5e6d869981767bcc0989a5e36f3b314db67f38460506e5929b4a82801f22fe9e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 400,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ryguy',
              winnerScore: 4265,
              winnerUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
            },
          },
        },
        '2025-04-07T13:40:00': {
          f6ea0b1c526a249f4f6507acf6ed6bfbf854afba235be271627aaf4f05167b25: {
            createdAt: 1744033244619,
            activityId: 'f6ea0b1c526a249f4f6507acf6ed6bfbf854afba235be271627aaf4f05167b25',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 2770,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 3235,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T13:42:00': {
          c0c329846b9d5324df8b2c371f1f12fa6f9ca4fd8c47d549c50f116a1be8cda5: {
            createdAt: 1744033374513,
            activityId: 'c0c329846b9d5324df8b2c371f1f12fa6f9ca4fd8c47d549c50f116a1be8cda5',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 3380,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4545,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
          f6c3d1453948671cc72923cb421a5c23ec536b8c08c185e3bdaad4a6a4cf5033: {
            createdAt: 1744033364504,
            activityId: 'f6c3d1453948671cc72923cb421a5c23ec536b8c08c185e3bdaad4a6a4cf5033',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'gravesal',
              loserScore: 0,
              loserUserId: '4esF0gzjHUb616OpARJ9pkWMAkw2',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 4240,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T13:46:00': {
          '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1': {
            createdAt: 1744033611203,
            activityId: '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1',
            data: {
              nick: 'cddih',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T13:49:00': {
          '6c8116c96a4742dd853675954a43262943f47133d7bb5f3710952c2e3557fe7a': {
            createdAt: 1744033781096,
            activityId: '6c8116c96a4742dd853675954a43262943f47133d7bb5f3710952c2e3557fe7a',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'puerto',
              loserScore: 185,
              loserUserId: 'EVyM1oeCRCVVbO9OqPAedE52Mck2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 355,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T13:51:00': {
          '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a': {
            createdAt: 1744033878800,
            activityId: '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a',
            data: {
              nick: 'duboybrown',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T13:54:00': {
          cdd662f52bb70b921ca6a7317e1d8c03af1c1b8e668be630a5dc8d4735316b94: {
            createdAt: 1744034071110,
            activityId: 'cdd662f52bb70b921ca6a7317e1d8c03af1c1b8e668be630a5dc8d4735316b94',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Filippo Di Gloria',
              loserScore: 70,
              loserUserId: '5c2acc42-81e8-46ab-adbf-42dea1f6a6c3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'duboybrown',
              winnerScore: 6275,
              winnerUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
            },
          },
        },
        '2025-04-07T14:02:00': {
          '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9': {
            createdAt: 1744034570441,
            activityId: '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9',
            data: {
              nick: 'daveman2',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:04:00': {
          '7d2d7d54b003ef81d04c835ea3b84ecbe21f2c121b191cf9c509ffa57b1f55e4': {
            createdAt: 1744034695456,
            activityId: '7d2d7d54b003ef81d04c835ea3b84ecbe21f2c121b191cf9c509ffa57b1f55e4',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ryguy',
              loserScore: 2830,
              loserUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 4760,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
          '8afd1a14f3a84329a5d80cd0e9c7258124b238316be867c3c41cc2ee48f9fa2e': {
            createdAt: 1744034672321,
            activityId: '8afd1a14f3a84329a5d80cd0e9c7258124b238316be867c3c41cc2ee48f9fa2e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Filippo Di Gloria',
              loserScore: 4085,
              loserUserId: '5c2acc42-81e8-46ab-adbf-42dea1f6a6c3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ryguy',
              winnerScore: 6025,
              winnerUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
            },
          },
        },
        '2025-04-07T14:09:00': {
          c3b14bb214ace7671a4189e61c91d853a43ce433baad8f76b310a4780f4d5350: {
            createdAt: 1744034970717,
            activityId: 'c3b14bb214ace7671a4189e61c91d853a43ce433baad8f76b310a4780f4d5350',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ryguy',
              loserScore: 15,
              loserUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'duboybrown',
              winnerScore: 25,
              winnerUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
            },
          },
        },
        '2025-04-07T14:15:00': {
          '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10': {
            createdAt: 1744035349453,
            activityId: '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10',
            data: {
              nick: 'batista',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:22:00': {
          '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2': {
            createdAt: 1744035743417,
            activityId: '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2',
            data: {
              nick: 'shoulo',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:24:00': {
          '40f9a6f1e7a2f2897ca5a74fc9c5b6264a809e464a623b412da572e015d11aa9': {
            createdAt: 1744035848373,
            activityId: '40f9a6f1e7a2f2897ca5a74fc9c5b6264a809e464a623b412da572e015d11aa9',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Neshdan',
              loserScore: 640,
              loserUserId: '46938e4c-bc24-45cd-9b93-460eef349086',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'kamyab',
              winnerScore: 4540,
              winnerUserId: '7JpyC0X8jtMdl48s2jnHdOD1Lje2',
            },
          },
        },
        '2025-04-07T14:25:00': {
          f21d3f74a8a4fe0d12c40e452cf32ad60c78e1fb2461b1235cfa0dc11986918e: {
            createdAt: 1744035905304,
            activityId: 'f21d3f74a8a4fe0d12c40e452cf32ad60c78e1fb2461b1235cfa0dc11986918e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Filippo Di Gloria',
              loserScore: 4155,
              loserUserId: '5c2acc42-81e8-46ab-adbf-42dea1f6a6c3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Ben Millett',
              winnerScore: 4610,
              winnerUserId: '3c3d2d57-e5a6-4a58-ba4c-ae8910ced856',
            },
          },
        },
        '2025-04-07T14:26:00': {
          '23e4a99b97cd27d8d85c1267b1134adf36a33f6b97adafb275e989c7d3245450': {
            createdAt: 1744035997111,
            activityId: '23e4a99b97cd27d8d85c1267b1134adf36a33f6b97adafb275e989c7d3245450',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Filippo Di Gloria',
              loserScore: 40,
              loserUserId: '5c2acc42-81e8-46ab-adbf-42dea1f6a6c3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'katie',
              winnerScore: 105,
              winnerUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
            },
          },
        },
        '2025-04-07T14:27:00': {
          '065e36754296328fb56990aa1247634c5f3aa2464e11a428adf7f24427890e21': {
            createdAt: 1744036020065,
            activityId: '065e36754296328fb56990aa1247634c5f3aa2464e11a428adf7f24427890e21',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'wally',
              loserScore: 410,
              loserUserId: 'Y2LG1dmuVRbsQimHvvuFaEKoeUi1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ryguy',
              winnerScore: 5805,
              winnerUserId: 'BXVUCyEqCpXrcUki8yfi54KGnsK2',
            },
          },
        },
        '2025-04-07T14:28:00': {
          '093199bbde4caa8115308536e0f13d1aacdb9ef12d5c9aea5b4eb751a824828e': {
            createdAt: 1744036113709,
            activityId: '093199bbde4caa8115308536e0f13d1aacdb9ef12d5c9aea5b4eb751a824828e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Ben Millett',
              loserScore: 6820,
              loserUserId: '3c3d2d57-e5a6-4a58-ba4c-ae8910ced856',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'JJM',
              winnerScore: 7445,
              winnerUserId: '2LaFZcWnJoZ6RJ4DkgF3i6s2YgV2',
            },
          },
        },
        '2025-04-07T14:35:00': {
          '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717': {
            createdAt: 1744036555664,
            activityId: '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717',
            data: {
              nick: 'Megan Kilburn',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:37:00': {
          '4b6e73bf0742a84496a6153a44558841c81f90b48628d8c618aacdaa262a38a0': {
            createdAt: 1744036629470,
            activityId: '4b6e73bf0742a84496a6153a44558841c81f90b48628d8c618aacdaa262a38a0',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 620,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'katie',
              winnerScore: 760,
              winnerUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
            },
          },
        },
        '2025-04-07T14:41:00': {
          acf35fa0faae9c8828f055fc240c4c28438b1bebb774d16ce0b301a7b467cda0: {
            createdAt: 1744036918629,
            activityId: 'acf35fa0faae9c8828f055fc240c4c28438b1bebb774d16ce0b301a7b467cda0',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'kamyab',
              loserScore: 3440,
              loserUserId: '7JpyC0X8jtMdl48s2jnHdOD1Lje2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'OmarCripto86',
              winnerScore: 6040,
              winnerUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
            },
          },
          bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b: {
            createdAt: 1744036860064,
            activityId: 'bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b',
            data: {
              nick: 'subacromial',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:44:00': {
          '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011': {
            createdAt: 1744037090963,
            activityId: '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011',
            data: {
              nick: 'mason',
              type: ActivityType.NewPlayer,
            },
          },
          ff760c219331141866132eace3c906ea4bc2ce3f89723cb3a264a7839ed4fa79: {
            createdAt: 1744037043549,
            activityId: 'ff760c219331141866132eace3c906ea4bc2ce3f89723cb3a264a7839ed4fa79',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Lincon',
              loserScore: 3890,
              loserUserId: 'K3RNN8TpyoMqeYoAUOljBLiOb3O2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 4440,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T14:51:00': {
          b7bed7b5bf357331c3f27c794b1cf0283372931693c3e5396cbbda17b7f58d9b: {
            createdAt: 1744037466408,
            activityId: 'b7bed7b5bf357331c3f27c794b1cf0283372931693c3e5396cbbda17b7f58d9b',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 4805,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 6790,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T14:59:00': {
          '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87': {
            createdAt: 1744037948962,
            activityId: '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87',
            data: {
              nick: 'popki',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:03:00': {
          a991fcc3b6a9ef812566f1635a7f471414d6218f7f7114eede708983a06edd47: {
            createdAt: 1744038198192,
            activityId: 'a991fcc3b6a9ef812566f1635a7f471414d6218f7f7114eede708983a06edd47',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Ben Millett',
              loserScore: 405,
              loserUserId: '3c3d2d57-e5a6-4a58-ba4c-ae8910ced856',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 3280,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T15:06:00': {
          '2651a4e221b516fe6c6f2af6d9274b690fe1b4193b24f5e1c0ac380bda7ad416': {
            createdAt: 1744038384921,
            activityId: '2651a4e221b516fe6c6f2af6d9274b690fe1b4193b24f5e1c0ac380bda7ad416',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 3175,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'wso18',
              winnerScore: 3870,
              winnerUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
            },
          },
        },
        '2025-04-07T15:11:00': {
          '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa': {
            createdAt: 1744038702679,
            activityId: '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa',
            data: {
              nick: 'Angel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:18:00': {
          '6594692046c70614ed568e302f01b4ef5dd825a9b47806061cbbdc72738fb416': {
            createdAt: 1744039080412,
            activityId: '6594692046c70614ed568e302f01b4ef5dd825a9b47806061cbbdc72738fb416',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'OmarCripto86',
              loserScore: 270,
              loserUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'spideman',
              winnerScore: 350,
              winnerUserId: 'ZMTLpjA302MAfCMB2ZUdHuvAlBp2',
            },
          },
        },
        '2025-04-07T15:20:00': {
          '5d9b1239d821576745b7597768aeca1a310c75cec490cc8828c280ff2c3839ca': {
            createdAt: 1744039248280,
            activityId: '5d9b1239d821576745b7597768aeca1a310c75cec490cc8828c280ff2c3839ca',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'rositca yaneva',
              loserScore: 0,
              loserUserId: '9ffd61a0-ff70-49e7-8a4f-aa09bd46f7ca',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 120,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
          '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7': {
            createdAt: 1744039215491,
            activityId: '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7',
            data: {
              nick: 'fuke your mom Angel',
              type: ActivityType.NewPlayer,
            },
          },
          defaf9a83f58dd8cbb59174953487333e2804eb2b3143c1b08e10acfc9befede: {
            createdAt: 1744039207536,
            activityId: 'defaf9a83f58dd8cbb59174953487333e2804eb2b3143c1b08e10acfc9befede',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'OmarCripto86',
              loserScore: 480,
              loserUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'JJM',
              winnerScore: 7110,
              winnerUserId: '2LaFZcWnJoZ6RJ4DkgF3i6s2YgV2',
            },
          },
        },
        '2025-04-07T15:23:00': {
          '14e7d335ecd918ce8ee2719ad59b2fd361df9768cb2ca6ea752f355ed2cdb705': {
            createdAt: 1744039408915,
            activityId: '14e7d335ecd918ce8ee2719ad59b2fd361df9768cb2ca6ea752f355ed2cdb705',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Woo',
              loserScore: 5395,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 6870,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T15:31:00': {
          efdc1134d4e9e711c731f64752404a4f097d18245178b6d87609aafdf6d04078: {
            createdAt: 1744039917504,
            activityId: 'efdc1134d4e9e711c731f64752404a4f097d18245178b6d87609aafdf6d04078',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 2910,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Gizmodeuss',
              winnerScore: 5160,
              winnerUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
            },
          },
        },
        '2025-04-07T15:43:00': {
          dd108b90d1e02119b1f9e3af2213a8f7951083f1f2a3cb64f968aa89aa7cdfa6: {
            createdAt: 1744040599359,
            activityId: 'dd108b90d1e02119b1f9e3af2213a8f7951083f1f2a3cb64f968aa89aa7cdfa6',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'duboybrown',
              loserScore: 0,
              loserUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4020,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T15:57:00': {
          '21e63395ee0e757108cd3b1d1e15aef00a4b1a9f382f69562d735ac1f347e82a': {
            createdAt: 1744041458286,
            activityId: '21e63395ee0e757108cd3b1d1e15aef00a4b1a9f382f69562d735ac1f347e82a',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'JEISSONR17',
              loserScore: 395,
              loserUserId: 'yu43e6fFgiPkAaClcDs3DwUEWSA2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ChickieDee',
              winnerScore: 4190,
              winnerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
            },
          },
        },
        '2025-04-07T15:58:00': {
          '119b457f0d4e158b0b055ad13efd875331bee75bd7f279d1f42daadb5dbeffae': {
            createdAt: 1744041505359,
            activityId: '119b457f0d4e158b0b055ad13efd875331bee75bd7f279d1f42daadb5dbeffae',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 0,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4255,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T16:01:00': {
          '25150ffaae79270fb3a7e816fe1b52b50c672b8a32486f5d0f62e30d26e84177': {
            createdAt: 1744041679398,
            activityId: '25150ffaae79270fb3a7e816fe1b52b50c672b8a32486f5d0f62e30d26e84177',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 305,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'gravesal',
              winnerScore: 4530,
              winnerUserId: '4esF0gzjHUb616OpARJ9pkWMAkw2',
            },
          },
        },
        '2025-04-07T16:02:00': {
          ac43349ec39ce76f3d50f7d4ec9f542ebd0fc9f680301a06c4d1a361b82d773c: {
            createdAt: 1744041744020,
            activityId: 'ac43349ec39ce76f3d50f7d4ec9f542ebd0fc9f680301a06c4d1a361b82d773c',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'JEISSONR17',
              loserScore: 4695,
              loserUserId: 'yu43e6fFgiPkAaClcDs3DwUEWSA2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 4800,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T16:05:00': {
          ca4b87e83e38152011e1524ab457b860da617284fb2a8841c460b4a4190fe109: {
            createdAt: 1744041946819,
            activityId: 'ca4b87e83e38152011e1524ab457b860da617284fb2a8841c460b4a4190fe109',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Woo',
              loserScore: 5205,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ProfessorSyma',
              winnerScore: 7395,
              winnerUserId: 'NHezp26RNOdWX1KZMgpCyzw57Mn1',
            },
          },
        },
        '2025-04-07T16:13:00': {
          '089281f8662afe50966f492d060ccc2d722512a6522ae1f48072a47f08b55532': {
            createdAt: 1744042402749,
            activityId: '089281f8662afe50966f492d060ccc2d722512a6522ae1f48072a47f08b55532',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 365,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 6855,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
          '6825adc117111a74eef497e5833d33682edbe789f458099d52d2f50fd008038e': {
            createdAt: 1744042425238,
            activityId: '6825adc117111a74eef497e5833d33682edbe789f458099d52d2f50fd008038e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 530,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'JEISSONR17',
              winnerScore: 5050,
              winnerUserId: 'yu43e6fFgiPkAaClcDs3DwUEWSA2',
            },
          },
        },
        '2025-04-07T16:16:00': {
          c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be: {
            createdAt: 1744042572569,
            activityId: 'c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be',
            data: {
              nick: 'Ma Bloq',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:18:00': {
          '8f84a7520df6e61625dcb185a30b34c472efdc132c941fd4a59de4f3fdc12afa': {
            createdAt: 1744042737605,
            activityId: '8f84a7520df6e61625dcb185a30b34c472efdc132c941fd4a59de4f3fdc12afa',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 4260,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 4805,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T16:20:00': {
          '6ad3c37b2f54f82c92749ef512077eb12c9f4b8d2f5f2959d4d049b60644752e': {
            createdAt: 1744042836370,
            activityId: '6ad3c37b2f54f82c92749ef512077eb12c9f4b8d2f5f2959d4d049b60644752e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 250,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ChickieDee',
              winnerScore: 5880,
              winnerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
            },
          },
          bbc0ac2f85228bae7d97627d241eb8390ab7b2ebd9d1cc457299d80cf91c0c7b: {
            createdAt: 1744042823404,
            activityId: 'bbc0ac2f85228bae7d97627d241eb8390ab7b2ebd9d1cc457299d80cf91c0c7b',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'boomersghost ',
              loserScore: 10,
              loserUserId: 'kCEyA8ZMKBMqX7IzZBtwo7xLcm72',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 110,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
        },
        '2025-04-07T16:24:00': {
          dd05f4b50286d16fb80467e3df480ffe25a0aa8d93a33fece324489d69cb4572: {
            createdAt: 1744043069309,
            activityId: 'dd05f4b50286d16fb80467e3df480ffe25a0aa8d93a33fece324489d69cb4572',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'faulty423',
              loserScore: 20,
              loserUserId: 'MxkXDZvGcxTQTG2XyfztpkMzz8h2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 90,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T16:27:00': {
          '3a160e805fd55d5ca772f44a36437c7c5c05dbab9fc6faec16e9af98d0f74094': {
            createdAt: 1744043238639,
            activityId: '3a160e805fd55d5ca772f44a36437c7c5c05dbab9fc6faec16e9af98d0f74094',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 630,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ChickieDee',
              winnerScore: 685,
              winnerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
            },
          },
        },
        '2025-04-07T16:28:00': {
          '1e5735c3f472d7a51efd287e87a4465f16932d8f904d4d4cf88df52b85fef90d': {
            createdAt: 1744043333071,
            activityId: '1e5735c3f472d7a51efd287e87a4465f16932d8f904d4d4cf88df52b85fef90d',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 10,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 60,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
          '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d': {
            createdAt: 1744043321475,
            activityId: '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d',
            data: {
              nick: 'Loser',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:30:00': {
          '03f208cded8e8bc312a1787778746b4d1f88f6550d4d09eee4f740f24a105eb9': {
            createdAt: 1744043455757,
            activityId: '03f208cded8e8bc312a1787778746b4d1f88f6550d4d09eee4f740f24a105eb9',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 870,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 1245,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T16:33:00': {
          '13420133ca7295df0f2aba137e2ea8eb10e613aa222dcdfa117cd53282acb020': {
            createdAt: 1744043586184,
            activityId: '13420133ca7295df0f2aba137e2ea8eb10e613aa222dcdfa117cd53282acb020',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 230,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 6185,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
          '4a1fd7a0a1a99a7566e785ee9c190d5504240b601a1fe533fc0886822a573d46': {
            createdAt: 1744043627795,
            activityId: '4a1fd7a0a1a99a7566e785ee9c190d5504240b601a1fe533fc0886822a573d46',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'conch',
              loserScore: 6005,
              loserUserId: '1d9f64b7-eeaa-4d25-9335-bb701bebfe70',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'spideman',
              winnerScore: 7170,
              winnerUserId: 'ZMTLpjA302MAfCMB2ZUdHuvAlBp2',
            },
          },
        },
        '2025-04-07T16:34:00': {
          '03345ea55afb472e6b5b9a30f99b252d8bf22f963309c3e3e4625be24424c208': {
            createdAt: 1744043683970,
            activityId: '03345ea55afb472e6b5b9a30f99b252d8bf22f963309c3e3e4625be24424c208',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 3890,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 5585,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
        },
        '2025-04-07T16:35:00': {
          '8f7702a8556c29341d3b0f81f30e55d6fbc6d05dbc52fcdc2bdb63c521d51d7d': {
            createdAt: 1744043733431,
            activityId: '8f7702a8556c29341d3b0f81f30e55d6fbc6d05dbc52fcdc2bdb63c521d51d7d',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 2780,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'Kyle Powell',
              winnerScore: 2855,
              winnerUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
            },
          },
        },
        '2025-04-07T16:36:00': {
          f7cdc44dca74c3cdcb90b0844240b2ea5947c3248cecfd42fac2431fe3446a25: {
            createdAt: 1744043811149,
            activityId: 'f7cdc44dca74c3cdcb90b0844240b2ea5947c3248cecfd42fac2431fe3446a25',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 325,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 3515,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
        },
        '2025-04-07T16:40:00': {
          '8b386987e14e0613e138edf0f4d1828652baa421de9ba1ae36fc5128ccfc3052': {
            createdAt: 1744044025772,
            activityId: '8b386987e14e0613e138edf0f4d1828652baa421de9ba1ae36fc5128ccfc3052',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 0,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 4395,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T16:41:00': {
          bb7f4a67b099fc801843e693f60266f5e8871b8e28a4746dd5521c41200428c1: {
            createdAt: 1744044063062,
            activityId: 'bb7f4a67b099fc801843e693f60266f5e8871b8e28a4746dd5521c41200428c1',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 6045,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 6400,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T16:44:00': {
          '98e3a1e1494dc392879459aacf5429182d197e789248fee49384f31bbd42141f': {
            createdAt: 1744044246337,
            activityId: '98e3a1e1494dc392879459aacf5429182d197e789248fee49384f31bbd42141f',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Loser',
              loserScore: 2415,
              loserUserId: 'z9kHOUcxSnQNOEGHTdEEquKHAkB3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 2910,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
          f11517af0827572b98914d4236470c7b425971eccbf31acb512f4a904ede3a42: {
            createdAt: 1744044250757,
            activityId: 'f11517af0827572b98914d4236470c7b425971eccbf31acb512f4a904ede3a42',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 0,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 130,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T16:46:00': {
          '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad': {
            createdAt: 1744044363811,
            activityId: '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad',
            data: {
              nick: 'Joining Soon',
              type: ActivityType.NewPlayer,
            },
          },
          '5b250c87bff829622356c288385f335170bbf3e1ba23c25d2a94335ee7b1fe47': {
            createdAt: 1744044409719,
            activityId: '5b250c87bff829622356c288385f335170bbf3e1ba23c25d2a94335ee7b1fe47',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 3730,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'puerto',
              winnerScore: 5360,
              winnerUserId: 'EVyM1oeCRCVVbO9OqPAedE52Mck2',
            },
          },
        },
        '2025-04-07T16:47:00': {
          '2ffcd425dc6d4d316df7ee5bc7c6662353e20d0fe5e191b7a1939d7b2725df60': {
            createdAt: 1744044474092,
            activityId: '2ffcd425dc6d4d316df7ee5bc7c6662353e20d0fe5e191b7a1939d7b2725df60',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 5445,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 6095,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T16:50:00': {
          f3f6133c72594cf04e95bc62fc5f0751d71226671b5c68fcee957b7e49d3c231: {
            createdAt: 1744044656896,
            activityId: 'f3f6133c72594cf04e95bc62fc5f0751d71226671b5c68fcee957b7e49d3c231',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 4215,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wally',
              winnerScore: 4680,
              winnerUserId: 'Y2LG1dmuVRbsQimHvvuFaEKoeUi1',
            },
          },
        },
        '2025-04-07T16:51:00': {
          '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0': {
            createdAt: 1744044683325,
            activityId: '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0',
            data: {
              nick: 'Colapinto',
              type: ActivityType.NewPlayer,
            },
          },
          a66927e53b20666f8a3b14b8e45599ef40a28ef8ba5bd7c3a3197b877c69deb3: {
            createdAt: 1744044705145,
            activityId: 'a66927e53b20666f8a3b14b8e45599ef40a28ef8ba5bd7c3a3197b877c69deb3',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 290,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'GamemasterHungary',
              winnerScore: 330,
              winnerUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
            },
          },
        },
        '2025-04-07T16:53:00': {
          '7ce9b070ba11b0dd29718affd9a7b529fc3dcefb69a0bcec001586aeac943ded': {
            createdAt: 1744044798182,
            activityId: '7ce9b070ba11b0dd29718affd9a7b529fc3dcefb69a0bcec001586aeac943ded',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ChickieDee',
              loserScore: 170,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'puerto',
              winnerScore: 285,
              winnerUserId: 'EVyM1oeCRCVVbO9OqPAedE52Mck2',
            },
          },
        },
        '2025-04-07T16:54:00': {
          '2784668fb7da5544a4f1933fb2fb65718f716a88931f945ea01a2a6ee86f006f': {
            createdAt: 1744044862285,
            activityId: '2784668fb7da5544a4f1933fb2fb65718f716a88931f945ea01a2a6ee86f006f',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'boomersghost ',
              loserScore: 105,
              loserUserId: 'kCEyA8ZMKBMqX7IzZBtwo7xLcm72',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wally',
              winnerScore: 215,
              winnerUserId: 'Y2LG1dmuVRbsQimHvvuFaEKoeUi1',
            },
          },
          '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa': {
            createdAt: 1744044888736,
            activityId: '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa',
            data: {
              nick: 'Saturno',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:56:00': {
          '850a797a7c41d129fdee6b7aceca559e392ace620b3c0d214d05ce3c08d4c22a': {
            createdAt: 1744045004015,
            activityId: '850a797a7c41d129fdee6b7aceca559e392ace620b3c0d214d05ce3c08d4c22a',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'GamemasterHungary',
              loserScore: 10,
              loserUserId: 'e22f6276-60d8-433f-839c-bd16da593c9a',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'katie',
              winnerScore: 3790,
              winnerUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
            },
          },
        },
        '2025-04-07T16:58:00': {
          a0e660824330363bba6db2c015270eb33602dd2a621b173dd208a693c5710f91: {
            createdAt: 1744045136233,
            activityId: 'a0e660824330363bba6db2c015270eb33602dd2a621b173dd208a693c5710f91',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'neckfoot',
              loserScore: 4865,
              loserUserId: 'f067b3f1-3620-4ea9-ac84-18de42911edf',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'puerto',
              winnerScore: 6260,
              winnerUserId: 'EVyM1oeCRCVVbO9OqPAedE52Mck2',
            },
          },
        },
        '2025-04-07T17:03:00': {
          '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559': {
            createdAt: 1744045401226,
            activityId: '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559',
            data: {
              nick: 'bostero topu',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:06:00': {
          '5b730db3df36c3e4512d59abecc81f5019bc202436860f03f01682b2f6996a3c': {
            createdAt: 1744045591444,
            activityId: '5b730db3df36c3e4512d59abecc81f5019bc202436860f03f01682b2f6996a3c',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'JJM',
              loserScore: 10,
              loserUserId: '2LaFZcWnJoZ6RJ4DkgF3i6s2YgV2',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'spideman',
              winnerScore: 700,
              winnerUserId: 'ZMTLpjA302MAfCMB2ZUdHuvAlBp2',
            },
          },
        },
        '2025-04-07T17:08:00': {
          '8041adc11140b32ea56352079e5a4329d98f05cbb2a686496b41cf1454c006e7': {
            createdAt: 1744045698120,
            activityId: '8041adc11140b32ea56352079e5a4329d98f05cbb2a686496b41cf1454c006e7',
            data: {
              bounty: {
                amount: 500,
                jackpot: false,
              },
              gameId: GameId.Solitaire,
              loserNick: 'Lincon',
              loserScore: 5840,
              loserUserId: 'K3RNN8TpyoMqeYoAUOljBLiOb3O2',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'spideman',
              winnerScore: 7445,
              winnerUserId: 'ZMTLpjA302MAfCMB2ZUdHuvAlBp2',
            },
          },
        },
        '2025-04-07T17:11:00': {
          f1285557b0ac3388b38c96d7ca2beb6c06880f19a3b15455cef15a8bd668949c: {
            createdAt: 1744045872085,
            activityId: 'f1285557b0ac3388b38c96d7ca2beb6c06880f19a3b15455cef15a8bd668949c',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'privateprinzesska',
              loserScore: 360,
              loserUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Neshdan',
              winnerScore: 685,
              winnerUserId: '46938e4c-bc24-45cd-9b93-460eef349086',
            },
          },
        },
        '2025-04-07T17:15:00': {
          f698e430d87d0df227c036177bff94719245a28c034f5683008232137f0fa9b2: {
            createdAt: 1744046131862,
            activityId: 'f698e430d87d0df227c036177bff94719245a28c034f5683008232137f0fa9b2',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'privateprinzesska',
              loserScore: 4805,
              loserUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4810,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T17:17:00': {
          '3f8681aa8ddef2f800d0f85810fe5ffc02586dfe0abc1b6850c55b100e6a7053': {
            createdAt: 1744046269024,
            activityId: '3f8681aa8ddef2f800d0f85810fe5ffc02586dfe0abc1b6850c55b100e6a7053',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Neshdan',
              loserScore: 6285,
              loserUserId: '46938e4c-bc24-45cd-9b93-460eef349086',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'OmarCripto86',
              winnerScore: 6365,
              winnerUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
            },
          },
        },
        '2025-04-07T17:22:00': {
          '460b886e0cb019129c58860c15a472b731bf197ab61e29fc6f77f3c9f4ff255a': {
            createdAt: 1744046550047,
            activityId: '460b886e0cb019129c58860c15a472b731bf197ab61e29fc6f77f3c9f4ff255a',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'neckfoot',
              loserScore: 220,
              loserUserId: 'f067b3f1-3620-4ea9-ac84-18de42911edf',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4745,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T17:23:00': {
          '32e2bb7e2af54d445d498994877b6ed6e110f94fd92e639cc177650ddcc2e832': {
            createdAt: 1744046628266,
            activityId: '32e2bb7e2af54d445d498994877b6ed6e110f94fd92e639cc177650ddcc2e832',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Bunker',
              loserScore: 4785,
              loserUserId: 'Ztj1gSWYbffo0PR8SC4HRCXb4au2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Abod H',
              winnerScore: 5100,
              winnerUserId: '98c9bb85-62fa-4678-a62f-08d96e796663',
            },
          },
        },
        '2025-04-07T17:25:00': {
          '5d619d8558a18fb4beb05aad51194baeb8107e9a48657966ba08a7c4bc586da7': {
            createdAt: 1744046718907,
            activityId: '5d619d8558a18fb4beb05aad51194baeb8107e9a48657966ba08a7c4bc586da7',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'privateprinzesska',
              loserScore: 6690,
              loserUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'OmarCripto86',
              winnerScore: 6845,
              winnerUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
            },
          },
        },
        '2025-04-07T17:26:00': {
          c208bd9e340e00c19846d9a70a8177a554b6675c7675fdff531801a99d4fef35: {
            createdAt: 1744046810133,
            activityId: 'c208bd9e340e00c19846d9a70a8177a554b6675c7675fdff531801a99d4fef35',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'privateprinzesska',
              loserScore: 170,
              loserUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 6385,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T17:36:00': {
          '95fbd6fc8bfe60f7d6422ecb424849b3f9d7d7aa897faa1d629d085dbf685463': {
            createdAt: 1744047390764,
            activityId: '95fbd6fc8bfe60f7d6422ecb424849b3f9d7d7aa897faa1d629d085dbf685463',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'OmarCripto86',
              loserScore: 1470,
              loserUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'privateprinzesska',
              winnerScore: 3555,
              winnerUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
            },
          },
        },
        '2025-04-07T17:37:00': {
          '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db': {
            createdAt: 1744047464940,
            activityId: '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db',
            data: {
              nick: 'Hakan Temel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:38:00': {
          '7b59143173983fb72dac60bab3fc32b6e35846951994728866ec4a6617ffc841': {
            createdAt: 1744047509397,
            activityId: '7b59143173983fb72dac60bab3fc32b6e35846951994728866ec4a6617ffc841',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 0,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'puerto',
              winnerScore: 5585,
              winnerUserId: 'EVyM1oeCRCVVbO9OqPAedE52Mck2',
            },
          },
        },
        '2025-04-07T17:39:00': {
          '49129ad93b2db69dc417c55eb33df0984c52431fa808a1f17ad5a7f097860aa2': {
            createdAt: 1744047580242,
            activityId: '49129ad93b2db69dc417c55eb33df0984c52431fa808a1f17ad5a7f097860aa2',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'letsgetabag',
              loserScore: 0,
              loserUserId: 'yfDmaQ97cXOEpa4uPIM2YVWJyXl1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Abod H',
              winnerScore: 55,
              winnerUserId: '98c9bb85-62fa-4678-a62f-08d96e796663',
            },
          },
        },
        '2025-04-07T17:45:00': {
          '0f56940f7905522ec6569c08ee27f24402e3fc90a94b8deca897f6c4604a415b': {
            createdAt: 1744047953564,
            activityId: '0f56940f7905522ec6569c08ee27f24402e3fc90a94b8deca897f6c4604a415b',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Roberto',
              loserScore: 3060,
              loserUserId: '9o0B8EY2t9g4EWto2Qt3AyODc313',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'katie',
              winnerScore: 3265,
              winnerUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
            },
          },
          bd35c7d114d05a7a46e6005aefa32f53eeb14bac410875b4aa53bbfa8e38d80f: {
            createdAt: 1744047940972,
            activityId: 'bd35c7d114d05a7a46e6005aefa32f53eeb14bac410875b4aa53bbfa8e38d80f',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 370,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 3310,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T17:47:00': {
          '0cf97e6a4a8af5f27755fdab7326982506022d6fcbf7a1fd64b98ff55ae097a9': {
            createdAt: 1744048058366,
            activityId: '0cf97e6a4a8af5f27755fdab7326982506022d6fcbf7a1fd64b98ff55ae097a9',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'ProfessorSyma',
              loserScore: 7230,
              loserUserId: 'NHezp26RNOdWX1KZMgpCyzw57Mn1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'privateprinzesska',
              winnerScore: 7595,
              winnerUserId: 'JqiNCGXjkaMqEYFPOYCaW0qcYfl1',
            },
          },
        },
        '2025-04-07T17:53:00': {
          '9da48a7b25d15dd1947ce6139fdf198c3167b7ee40305f7f1e95aaf05f608b30': {
            createdAt: 1744048417163,
            activityId: '9da48a7b25d15dd1947ce6139fdf198c3167b7ee40305f7f1e95aaf05f608b30',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 0,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ProfessorSyma',
              winnerScore: 3870,
              winnerUserId: 'NHezp26RNOdWX1KZMgpCyzw57Mn1',
            },
          },
        },
        '2025-04-07T17:54:00': {
          '205fe09651ef66ff9a7cabc3c64a59685cd223cb22a6b3c05d0be7ed2c0aeabc': {
            createdAt: 1744048497031,
            activityId: '205fe09651ef66ff9a7cabc3c64a59685cd223cb22a6b3c05d0be7ed2c0aeabc',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 315,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'boomersghost ',
              winnerScore: 3840,
              winnerUserId: 'kCEyA8ZMKBMqX7IzZBtwo7xLcm72',
            },
          },
        },
        '2025-04-07T17:56:00': {
          '5b50041a993ad918f82f620f64dcb6560fbff32fad4f7511aed1daedd1d3ea73': {
            createdAt: 1744048614429,
            activityId: '5b50041a993ad918f82f620f64dcb6560fbff32fad4f7511aed1daedd1d3ea73',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'bagkoyy',
              loserScore: 70,
              loserUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'mikedegu',
              winnerScore: 185,
              winnerUserId: 'fd0cf7d9-3135-4835-8747-b0efc10d82c2',
            },
          },
          '819223e1d9539e655bcd64c33343038e495ca407a71ea251168d1664d2b18635': {
            createdAt: 1744048568534,
            activityId: '819223e1d9539e655bcd64c33343038e495ca407a71ea251168d1664d2b18635',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 0,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 5265,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
        '2025-04-07T18:02:00': {
          '010a83c92bd8c8b0a7a8b555164b0c8505872d4053c330a32327c64a3bab7f40': {
            createdAt: 1744048934839,
            activityId: '010a83c92bd8c8b0a7a8b555164b0c8505872d4053c330a32327c64a3bab7f40',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Neshdan',
              loserScore: 60,
              loserUserId: '46938e4c-bc24-45cd-9b93-460eef349086',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ProfessorSyma',
              winnerScore: 6620,
              winnerUserId: 'NHezp26RNOdWX1KZMgpCyzw57Mn1',
            },
          },
        },
        '2025-04-07T18:04:00': {
          c52616174ffe472e7860e31a74d58b9a704679ae55abb88dcc929a70821d74ba: {
            createdAt: 1744049050324,
            activityId: 'c52616174ffe472e7860e31a74d58b9a704679ae55abb88dcc929a70821d74ba',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'wso18',
              loserScore: 270,
              loserUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 6820,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T18:07:00': {
          d91b0ec7d72dcdadb24a8f6ce367fbca65a98d9849df644de6109c7e9d11b053: {
            createdAt: 1744049263785,
            activityId: 'd91b0ec7d72dcdadb24a8f6ce367fbca65a98d9849df644de6109c7e9d11b053',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Kyle Powell',
              loserScore: 820,
              loserUserId: '9defb230-08bf-443c-b00e-9211ee1e4596',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'katie',
              winnerScore: 3945,
              winnerUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
            },
          },
        },
        '2025-04-07T18:08:00': {
          '48e90dbb713e2d7624458a690181aef61019c6d987d5b0268a932e3873e73ce7': {
            createdAt: 1744049290252,
            activityId: '48e90dbb713e2d7624458a690181aef61019c6d987d5b0268a932e3873e73ce7',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 285,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'mikedegu',
              winnerScore: 400,
              winnerUserId: 'fd0cf7d9-3135-4835-8747-b0efc10d82c2',
            },
          },
        },
        '2025-04-07T18:29:00': {
          c9ddb609e80383655e375691a083898f22d8506c777f5284dc914f204e2913cb: {
            createdAt: 1744050547820,
            activityId: 'c9ddb609e80383655e375691a083898f22d8506c777f5284dc914f204e2913cb',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Robert J Strickland',
              loserScore: 400,
              loserUserId: '565c34b4-0ffa-4b15-868a-2dcf5acc917f',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 4725,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T18:38:00': {
          '01f03a34840c380bac65272731fa3ecca1a9a550be0423430c378d5927e13e5d': {
            createdAt: 1744051090728,
            activityId: '01f03a34840c380bac65272731fa3ecca1a9a550be0423430c378d5927e13e5d',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'novaburst',
              loserScore: 65,
              loserUserId: 'qsVArlNRyvWj5iOVgRAsvfTfVGk2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'PrestonsGirl ',
              winnerScore: 275,
              winnerUserId: 'DDvKjZX7HJcwzoE5pg3NfjAERIv1',
            },
          },
        },
        '2025-04-07T18:39:00': {
          '406c2d2b6451dbe2548cdd9a242ac64271841eba67df63d4e7bcda7262a6790e': {
            createdAt: 1744051194881,
            activityId: '406c2d2b6451dbe2548cdd9a242ac64271841eba67df63d4e7bcda7262a6790e',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'random39',
              loserScore: 2320,
              loserUserId: 'BIMH6yaAn7NapBRCl03x7na5Ji73',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'godneverdie',
              winnerScore: 2765,
              winnerUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
            },
          },
        },
        '2025-04-07T18:41:00': {
          '6d3da4ee7e2b4a0cc48e658c5d3d41e586a4872599cfd143f7dddbc21d14fd6f': {
            createdAt: 1744051266566,
            activityId: '6d3da4ee7e2b4a0cc48e658c5d3d41e586a4872599cfd143f7dddbc21d14fd6f',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Woo',
              loserScore: 380,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Erin Hagg',
              winnerScore: 1000,
              winnerUserId: '2defb36e-e698-4679-800b-be052c7e174a',
            },
          },
        },
        '2025-04-07T18:42:00': {
          '336dc730787254bc515c690f91d94d252c67545c4d747769b25da627b80a3b92': {
            createdAt: 1744051346376,
            activityId: '336dc730787254bc515c690f91d94d252c67545c4d747769b25da627b80a3b92',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'Erin Hagg',
              loserScore: 4120,
              loserUserId: '2defb36e-e698-4679-800b-be052c7e174a',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'random39',
              winnerScore: 4470,
              winnerUserId: 'BIMH6yaAn7NapBRCl03x7na5Ji73',
            },
          },
        },
        '2025-04-07T18:50:00': {
          dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b: {
            createdAt: 1744051836883,
            activityId: 'dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b',
            data: {
              nick: 'Schneider',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T18:53:00': {
          '242a20ccb829143dd7d798ba117887acb200c12bde674ae627c542906edb49c2': {
            createdAt: 1744052026458,
            activityId: '242a20ccb829143dd7d798ba117887acb200c12bde674ae627c542906edb49c2',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'katie',
              loserScore: 460,
              loserUserId: 's0Qlml5rUfftTdPvAOEfBeaGslT2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'Erin Hagg',
              winnerScore: 2780,
              winnerUserId: '2defb36e-e698-4679-800b-be052c7e174a',
            },
          },
        },
        '2025-04-07T18:54:00': {
          ce10f33c5616056870a7f1779816e28ff3729717d14373d5e7c6e029091e4bbb: {
            createdAt: 1744052093178,
            activityId: 'ce10f33c5616056870a7f1779816e28ff3729717d14373d5e7c6e029091e4bbb',
            data: {
              gameId: GameId.Solitaire,
              loserNick: 'godneverdie',
              loserScore: 10,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'bagkoyy',
              winnerScore: 145,
              winnerUserId: 'KCby6YRbgJZ6xV7XFWd6ltx3Ppf2',
            },
          },
        },
      },
    },
  },
};

export const ACTIVITY_FEED_BLACKJACK_MOCK: ActivityFeedMock = {
  status: 200,
  body: {
    msg: 'Activity feed',
    status: 200,
    data: {
      serverTime: 1744052226255,
      activities: {
        '2025-04-07T12:57:00': {
          '82635eb32024501e965d5416e6057025e7ff2cfbb3c63e247d5f08b6117946c3': {
            createdAt: 1744030625106,
            activityId: '82635eb32024501e965d5416e6057025e7ff2cfbb3c63e247d5f08b6117946c3',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 0,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1340,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
          '9dbe2ab2f14255f8ff1549e0976c99f761199d3200f3c6ee7f3e74103a50d7d6': {
            createdAt: 1744030653304,
            activityId: '9dbe2ab2f14255f8ff1549e0976c99f761199d3200f3c6ee7f3e74103a50d7d6',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'JankBella',
              loserScore: 1000,
              loserUserId: 'BDj1hHMAFVXMIvbpp8AmMKTfI4x1',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1420,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:02:00': {
          dfcd109cd8cda5cea17cdc5e8f3ad00f2fe45dee46f71a2b1d144167e0ac2336: {
            createdAt: 1744030934618,
            activityId: 'dfcd109cd8cda5cea17cdc5e8f3ad00f2fe45dee46f71a2b1d144167e0ac2336',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 30,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 100,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T13:03:00': {
          '30369942efb238d0f46810f6dd6b6ea2b94ba58a7c985b336e550e4d3dec25fb': {
            createdAt: 1744030996006,
            activityId: '30369942efb238d0f46810f6dd6b6ea2b94ba58a7c985b336e550e4d3dec25fb',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'John Araiz',
              loserScore: 300,
              loserUserId: 'e7f9c85a-f76e-4f3e-bf39-3bdc06d43fae',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Ishmael Watkins',
              winnerScore: 600,
              winnerUserId: '6e403e03-db95-4617-84a3-c8fa38a9ecc9',
            },
          },
        },
        '2025-04-07T13:06:00': {
          '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16': {
            createdAt: 1744031201542,
            activityId: '4e07446c77e5a9c02d4c1c5322fe77f6844e220cc510f584a1f16e4d19550f16',
            data: {
              nick: 'Hangula Kriana',
              type: ActivityType.NewPlayer,
            },
          },
          '9bebbd702959b07f1855cc4f23ed53ac95dac42451cad17c6960adb62a8f80d6': {
            createdAt: 1744031212484,
            activityId: '9bebbd702959b07f1855cc4f23ed53ac95dac42451cad17c6960adb62a8f80d6',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 1330,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 2760,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T13:10:00': {
          '3e92da4448e697241ccf5aa54acf0a392423be8597353b7b6b3bd3bbf54aa5c1': {
            createdAt: 1744031406986,
            activityId: '3e92da4448e697241ccf5aa54acf0a392423be8597353b7b6b3bd3bbf54aa5c1',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Hangula Kriana',
              loserScore: 30,
              loserUserId: '02e02792-0970-4616-8211-a000ed31213e',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 950,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:14:00': {
          d50a685bc491a9d98667be1a41cc6e8980550354e040e55f0acca873174b6b83: {
            createdAt: 1744031670783,
            activityId: 'd50a685bc491a9d98667be1a41cc6e8980550354e040e55f0acca873174b6b83',
            data: {
              bounty: {
                amount: 5,
                jackpot: false,
              },
              gameId: GameId.Blackjack,
              loserNick: 'OmarCripto86',
              loserScore: 960,
              loserUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'wso18',
              winnerScore: 1180,
              winnerUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
            },
          },
        },
        '2025-04-07T13:18:00': {
          '58c4d062f14feb58d6457fca467a96d2421bb905514113bc07b66e1c976293d1': {
            createdAt: 1744031922573,
            activityId: '58c4d062f14feb58d6457fca467a96d2421bb905514113bc07b66e1c976293d1',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 1775,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'jasonmramos',
              winnerScore: 2185,
              winnerUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
            },
          },
        },
        '2025-04-07T13:20:00': {
          '48978d79303cf586a2604fc335ed4a115c59a04a5df5af98ca31e4f3d93c3530': {
            createdAt: 1744032056501,
            activityId: '48978d79303cf586a2604fc335ed4a115c59a04a5df5af98ca31e4f3d93c3530',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 350,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jasonmramos',
              winnerScore: 800,
              winnerUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
            },
          },
          e011096ab3975160ab18c4699abc56ccf7060e87bb33a7dfabc781e180e1f242: {
            createdAt: 1744032008396,
            activityId: 'e011096ab3975160ab18c4699abc56ccf7060e87bb33a7dfabc781e180e1f242',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 100,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Michael Goodacre',
              winnerScore: 3750,
              winnerUserId: '5b7d91d6-4bb8-43e7-84b4-73e7a4b2032e',
            },
          },
        },
        '2025-04-07T13:35:00': {
          d2202bcae4d03196da3fa32ddb3ae94598786943bf2bb4cac74b466565dbfe26: {
            createdAt: 1744032909350,
            activityId: 'd2202bcae4d03196da3fa32ddb3ae94598786943bf2bb4cac74b466565dbfe26',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Michael Goodacre',
              loserScore: 0,
              loserUserId: '5b7d91d6-4bb8-43e7-84b4-73e7a4b2032e',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1465,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T13:36:00': {
          '97d1b9b9501c4a896d5a53f898e7a2ed16b5534981c5bed9d757953faf6716dd': {
            createdAt: 1744033008587,
            activityId: '97d1b9b9501c4a896d5a53f898e7a2ed16b5534981c5bed9d757953faf6716dd',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Michael Goodacre',
              loserScore: 0,
              loserUserId: '5b7d91d6-4bb8-43e7-84b4-73e7a4b2032e',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Cryptonator',
              winnerScore: 1150,
              winnerUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
            },
          },
        },
        '2025-04-07T13:37:00': {
          '1920871995c587b66eae5960a8342ddad56b4adea802ff6659841213dc044407': {
            createdAt: 1744033060033,
            activityId: '1920871995c587b66eae5960a8342ddad56b4adea802ff6659841213dc044407',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'wso18',
              loserScore: 500,
              loserUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1300,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:39:00': {
          '047a8466d452a0e9c3537ecf999af6154441d54768e7f395618c2ec114d0c549': {
            createdAt: 1744033154504,
            activityId: '047a8466d452a0e9c3537ecf999af6154441d54768e7f395618c2ec114d0c549',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 700,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'jasonmramos',
              winnerScore: 1100,
              winnerUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
            },
          },
        },
        '2025-04-07T13:42:00': {
          f7175b369bd7828b8bbafa11c95bb6a75e46897fce35aac27f46d55805c04dae: {
            createdAt: 1744033327216,
            activityId: 'f7175b369bd7828b8bbafa11c95bb6a75e46897fce35aac27f46d55805c04dae',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 920,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1200,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:44:00': {
          '62309570ccb8cef23277afb43c06faa8f2f5a92f56d1620676e72f30d22795c4': {
            createdAt: 1744033469602,
            activityId: '62309570ccb8cef23277afb43c06faa8f2f5a92f56d1620676e72f30d22795c4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 900,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1585,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          ff4f6af9f48780b38678dbb338fbadf53fe040063268cf710b4c8c1e5c4443a8: {
            createdAt: 1744033448412,
            activityId: 'ff4f6af9f48780b38678dbb338fbadf53fe040063268cf710b4c8c1e5c4443a8',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Running',
              loserScore: 0,
              loserUserId: 'MqL8KlOXGNajWFThPljAFpLiipX2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 600,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:46:00': {
          '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1': {
            createdAt: 1744033611203,
            activityId: '26e486d6972ce3ebe1acee53627e1ab83af5ac3f00b2fee12d9ba41d853034f1',
            data: {
              nick: 'cddih',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T13:51:00': {
          '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a': {
            createdAt: 1744033878800,
            activityId: '134b30c4e9c4f89eec69c1a5544210cc78425d14f56d80134af8a05c10a2b44a',
            data: {
              nick: 'duboybrown',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T13:53:00': {
          '46eb561efe1833b0d3b753ca51d8f2ac88c6d2c69056076d40ec2d26b0d8f072': {
            createdAt: 1744033990630,
            activityId: '46eb561efe1833b0d3b753ca51d8f2ac88c6d2c69056076d40ec2d26b0d8f072',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jasonmramos',
              loserScore: 1000,
              loserUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1410,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T13:55:00': {
          '326f5bb16bc85c2dbec24e758c7225c05e50faa3c7e5b77827c98a2b85c985d9': {
            createdAt: 1744034154475,
            activityId: '326f5bb16bc85c2dbec24e758c7225c05e50faa3c7e5b77827c98a2b85c985d9',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jasonmramos',
              loserScore: 1200,
              loserUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1350,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T13:57:00': {
          '1a148d3d190a2753880469ee165ac4aa9e5c809cbe38466cbe07a745445862bf': {
            createdAt: 1744034235446,
            activityId: '1a148d3d190a2753880469ee165ac4aa9e5c809cbe38466cbe07a745445862bf',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Running',
              loserScore: 0,
              loserUserId: 'MqL8KlOXGNajWFThPljAFpLiipX2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1400,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T13:58:00': {
          '98febccc4acba19a4d0a6908509a2efff2cbbfbfa30af8b8cb73da71cfdaf1df': {
            createdAt: 1744034294613,
            activityId: '98febccc4acba19a4d0a6908509a2efff2cbbfbfa30af8b8cb73da71cfdaf1df',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 650,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'jasonmramos',
              winnerScore: 1100,
              winnerUserId: 'cc5eb0cd-26cd-4dbd-a2aa-55e282bcf72f',
            },
          },
        },
        '2025-04-07T14:02:00': {
          '20efb9e5c8be8524316ae5d3302b701132bd133e190828006a8b3ae7e04a14c2': {
            createdAt: 1744034537759,
            activityId: '20efb9e5c8be8524316ae5d3302b701132bd133e190828006a8b3ae7e04a14c2',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Hammer_hard',
              loserScore: 65,
              loserUserId: '8e382345-5569-46f3-92e8-0e3c678b1b13',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 150,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9': {
            createdAt: 1744034570441,
            activityId: '76e68af10d165ad68f282f6ff94e5a0396f9cccd9c11d4357d634322619062d9',
            data: {
              nick: 'daveman2',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:03:00': {
          dd85e5b2de13893404baa923fcad53358a22795b5c518348cb6bd6b1558068f6: {
            createdAt: 1744034625409,
            activityId: 'dd85e5b2de13893404baa923fcad53358a22795b5c518348cb6bd6b1558068f6',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Jeramie Ayala',
              loserScore: 0,
              loserUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'duboybrown',
              winnerScore: 1240,
              winnerUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
            },
          },
        },
        '2025-04-07T14:04:00': {
          be13f4b3c9ba6229c06930d24aa6b6575be597668c0ebd360cabb28436c27c81: {
            createdAt: 1744034643532,
            activityId: 'be13f4b3c9ba6229c06930d24aa6b6575be597668c0ebd360cabb28436c27c81',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Jeramie Ayala',
              loserScore: 0,
              loserUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'la mente maestra ',
              winnerScore: 500,
              winnerUserId: 'a9WXetNCuIWQP5ABC8rQoLZ5YOZ2',
            },
          },
        },
        '2025-04-07T14:05:00': {
          '753679ec968ccc737f0d7acc1c94300da34b7336cdec039d7a743116fb8a6100': {
            createdAt: 1744034735538,
            activityId: '753679ec968ccc737f0d7acc1c94300da34b7336cdec039d7a743116fb8a6100',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'daveman2',
              loserScore: 1110,
              loserUserId: 'kbfVjcWzYNYXTdrpGQptsk8SkJk2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1120,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T14:09:00': {
          a027a8d6cda4520656fcdb8585fc7de1372748901f85dba8e7d56542d3b2d1ae: {
            createdAt: 1744034946087,
            activityId: 'a027a8d6cda4520656fcdb8585fc7de1372748901f85dba8e7d56542d3b2d1ae',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 0,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 750,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T14:11:00': {
          '53c766f7ef55689ab5ea0d447177d3cae2a3c9b8fee4eaea0bbd8f8465ea19e9': {
            createdAt: 1744035102722,
            activityId: '53c766f7ef55689ab5ea0d447177d3cae2a3c9b8fee4eaea0bbd8f8465ea19e9',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1420,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wizard0777',
              winnerScore: 2040,
              winnerUserId: '1Xlc0x05PUXJZjfJ80gjk0kEKuH2',
            },
          },
        },
        '2025-04-07T14:12:00': {
          bf74e8cacc1aee6641432b20dd773f1617d1d92a9c33521e3d44c08cc2eec9df: {
            createdAt: 1744035179414,
            activityId: 'bf74e8cacc1aee6641432b20dd773f1617d1d92a9c33521e3d44c08cc2eec9df',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 50,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'jlasante',
              winnerScore: 1430,
              winnerUserId: 'ryvY5n5TwlOPUgWHISENleVFlLk1',
            },
          },
        },
        '2025-04-07T14:13:00': {
          '2618e669488a534edc661f5aa49b330095e96d54d11ed886b0273a5c52281a4f': {
            createdAt: 1744035206517,
            activityId: '2618e669488a534edc661f5aa49b330095e96d54d11ed886b0273a5c52281a4f',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Omar Soto',
              loserScore: 950,
              loserUserId: '0be13c53-5246-49ea-bd76-6b19ecfbadc4',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1100,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          faa24df6166fb8fa0e3d91b07e8e87a6f0c24e328628519a55a48165a7605ad4: {
            createdAt: 1744035199045,
            activityId: 'faa24df6166fb8fa0e3d91b07e8e87a6f0c24e328628519a55a48165a7605ad4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'duboybrown',
              loserScore: 150,
              loserUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1320,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T14:15:00': {
          '11377e88525d609dfb09cba66340865531958018ba31643d17b453faf35f50b7': {
            createdAt: 1744035340346,
            activityId: '11377e88525d609dfb09cba66340865531958018ba31643d17b453faf35f50b7',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1100,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'duboybrown',
              winnerScore: 1190,
              winnerUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
            },
          },
          '2afe853d6869c6fecf64be12a4f14bc80c9853d278da4ea98562f2f4ff790c69': {
            createdAt: 1744035328717,
            activityId: '2afe853d6869c6fecf64be12a4f14bc80c9853d278da4ea98562f2f4ff790c69',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Hammer_hard',
              loserScore: 0,
              loserUserId: '8e382345-5569-46f3-92e8-0e3c678b1b13',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 230,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10': {
            createdAt: 1744035349453,
            activityId: '7283572afb9a00ec97a16dcb78c64e89a5107397f8e982c733930d3120513d10',
            data: {
              nick: 'batista',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:16:00': {
          '9f79b40bedd4238e8ce72e56e0545a528b7127ca5e6770637639b6912459f45a': {
            createdAt: 1744035376827,
            activityId: '9f79b40bedd4238e8ce72e56e0545a528b7127ca5e6770637639b6912459f45a',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'takumar',
              loserScore: 0,
              loserUserId: '536f560c-ef50-4c9d-930a-30832a52f5e4',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'Hammer_hard',
              winnerScore: 400,
              winnerUserId: '8e382345-5569-46f3-92e8-0e3c678b1b13',
            },
          },
        },
        '2025-04-07T14:19:00': {
          f30cbd474ed65708396e966927a751f564cb9819260aff560192f816c3e24dd3: {
            createdAt: 1744035592429,
            activityId: 'f30cbd474ed65708396e966927a751f564cb9819260aff560192f816c3e24dd3',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 440,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'Hammer_hard',
              winnerScore: 1025,
              winnerUserId: '8e382345-5569-46f3-92e8-0e3c678b1b13',
            },
          },
        },
        '2025-04-07T14:20:00': {
          '854816ad4d705df656e6b6853b3e3624f368c986def5fd6db6c0c9f2dc5199fe': {
            createdAt: 1744035653713,
            activityId: '854816ad4d705df656e6b6853b3e3624f368c986def5fd6db6c0c9f2dc5199fe',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1150,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Ishmael Watkins',
              winnerScore: 1600,
              winnerUserId: '6e403e03-db95-4617-84a3-c8fa38a9ecc9',
            },
          },
        },
        '2025-04-07T14:22:00': {
          '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2': {
            createdAt: 1744035743417,
            activityId: '65f40f3f8ba881c46a2e3d503822c6d15e8fa53f65869364e187256d940aedb2',
            data: {
              nick: 'shoulo',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:23:00': {
          '692d2019ca99d8049b09c6043629c8e7274cdde9271566b0cbdc7878804047e1': {
            createdAt: 1744035814436,
            activityId: '692d2019ca99d8049b09c6043629c8e7274cdde9271566b0cbdc7878804047e1',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1200,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Lincon',
              winnerScore: 1300,
              winnerUserId: 'K3RNN8TpyoMqeYoAUOljBLiOb3O2',
            },
          },
        },
        '2025-04-07T14:24:00': {
          '6b3b730824dcffec48ec411185230cd19495e7b191b15a4c43e94b9ced0118ac': {
            createdAt: 1744035856360,
            activityId: '6b3b730824dcffec48ec411185230cd19495e7b191b15a4c43e94b9ced0118ac',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Omar Soto',
              loserScore: 340,
              loserUserId: '0be13c53-5246-49ea-bd76-6b19ecfbadc4',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1662,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T14:25:00': {
          '83abdf1cf176e868ce79b778da78ae09eb3e4cc9616f00f7eaa46e5cca4ee324': {
            createdAt: 1744035911066,
            activityId: '83abdf1cf176e868ce79b778da78ae09eb3e4cc9616f00f7eaa46e5cca4ee324',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'OmarCripto86',
              loserScore: 300,
              loserUserId: '71fcc902-113d-4a36-8f6d-3b7e9f84d50c',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Fajar Fajar',
              winnerScore: 1120,
              winnerUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
            },
          },
        },
        '2025-04-07T14:26:00': {
          '0af75e0cacd08206ceb294d95a1dfc09eca1d6100522de0628d350e6295f2228': {
            createdAt: 1744035984406,
            activityId: '0af75e0cacd08206ceb294d95a1dfc09eca1d6100522de0628d350e6295f2228',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Buck Vice',
              loserScore: 1750,
              loserUserId: '42ed13ce-c8f0-46d3-8354-ed401947e5f3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 2040,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T14:27:00': {
          '1dacf39b158fe2c0f2172a9945db272b5ededf4739e5a766a1122f83c44d17e4': {
            createdAt: 1744036077599,
            activityId: '1dacf39b158fe2c0f2172a9945db272b5ededf4739e5a766a1122f83c44d17e4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'takumar',
              loserScore: 1900,
              loserUserId: '536f560c-ef50-4c9d-930a-30832a52f5e4',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 2610,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T14:28:00': {
          be5ad07455a8043c725b475b2fe361d32d6c351c4484a0e09ffa89645de77500: {
            createdAt: 1744036090326,
            activityId: 'be5ad07455a8043c725b475b2fe361d32d6c351c4484a0e09ffa89645de77500',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 350,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 500,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T14:31:00': {
          bbcf6f542fb64a1b5cbcfabc39ae1e456ffbc83016f630c8a42dfd04bd5dd005: {
            createdAt: 1744036308316,
            activityId: 'bbcf6f542fb64a1b5cbcfabc39ae1e456ffbc83016f630c8a42dfd04bd5dd005',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1150,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 1600,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T14:35:00': {
          '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717': {
            createdAt: 1744036555664,
            activityId: '081baff413845d4453c9bc4499180cbcd12a9055b788f8c7d0d9e27a83d18717',
            data: {
              nick: 'Megan Kilburn',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:38:00': {
          '4f7abb9b1e743fe461917188e12dbc81720ee3f0684552ce6805bea93aa3f84f': {
            createdAt: 1744036690620,
            activityId: '4f7abb9b1e743fe461917188e12dbc81720ee3f0684552ce6805bea93aa3f84f',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Bras030',
              loserScore: 1670,
              loserUserId: 'uqET5CVuhtNmEHUTF2Uc0Zj7fxr1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 1700,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T14:41:00': {
          bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b: {
            createdAt: 1744036860064,
            activityId: 'bcf9b6ee3c1fd31dcd144c1e9f1bfe88e2162dc0e5dd24fb2897d5c335a79f2b',
            data: {
              nick: 'subacromial',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:44:00': {
          '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011': {
            createdAt: 1744037090963,
            activityId: '9d81aa7ec528359305183cc3af411d48a377b9b85fe3b9821dbde52a1d84b011',
            data: {
              nick: 'mason',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T14:54:00': {
          c605aa60d092a68df3ff82109cc395b3485e10a652fc210710837bc33f7370e6: {
            createdAt: 1744037698428,
            activityId: 'c605aa60d092a68df3ff82109cc395b3485e10a652fc210710837bc33f7370e6',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 322,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 760,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T14:57:00': {
          '5ce4f4b473e12507a4266b1127f0fc4eb81c30b88930a8b1c1faf5fe0d7c2e29': {
            createdAt: 1744037820541,
            activityId: '5ce4f4b473e12507a4266b1127f0fc4eb81c30b88930a8b1c1faf5fe0d7c2e29',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 2700,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 3220,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T14:58:00': {
          a312603a27eb5fdb16dbeb830d46da03a94abae0adf0f20600b0acae69992427: {
            createdAt: 1744037932517,
            activityId: 'a312603a27eb5fdb16dbeb830d46da03a94abae0adf0f20600b0acae69992427',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'ferrari16',
              loserScore: 0,
              loserUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 382,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T14:59:00': {
          '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87': {
            createdAt: 1744037948962,
            activityId: '10711cc3c62a2a3153ddd10d8293315ced4dda491a329fa8a474cf21e6f89d87',
            data: {
              nick: 'popki',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:00:00': {
          '25bcccb38290662284e94b5ae7059673e59fd39dc4d3022ae2a7603d8e157d3e': {
            createdAt: 1744038030794,
            activityId: '25bcccb38290662284e94b5ae7059673e59fd39dc4d3022ae2a7603d8e157d3e',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 1272,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wizard0777',
              winnerScore: 1740,
              winnerUserId: '1Xlc0x05PUXJZjfJ80gjk0kEKuH2',
            },
          },
        },
        '2025-04-07T15:05:00': {
          e1828f38bf6238f16afdb7ac375cfad71bb7470cc5fcd0f26d892867d2a54403: {
            createdAt: 1744038311774,
            activityId: 'e1828f38bf6238f16afdb7ac375cfad71bb7470cc5fcd0f26d892867d2a54403',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Megan Kilburn',
              loserScore: 0,
              loserUserId: '73fd0989-51b0-4038-a86d-33a1e434e36b',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1060,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T15:09:00': {
          a5d63f0b4694d909a44a46ee33e757f07b6668431ef31c115d375de5cf02cc23: {
            createdAt: 1744038564781,
            activityId: 'a5d63f0b4694d909a44a46ee33e757f07b6668431ef31c115d375de5cf02cc23',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1100,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1215,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T15:10:00': {
          '307e29b5a6fa4e7f349c31cf090aac9b7d53ba98c9858dd4e9dd0807a6dddd74': {
            createdAt: 1744038607741,
            activityId: '307e29b5a6fa4e7f349c31cf090aac9b7d53ba98c9858dd4e9dd0807a6dddd74',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Megan Kilburn',
              loserScore: 0,
              loserUserId: '73fd0989-51b0-4038-a86d-33a1e434e36b',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 1400,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T15:11:00': {
          '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa': {
            createdAt: 1744038702679,
            activityId: '98455bf5b0392ba806acc9472b1a4ad77149a840be40969df16661074a9048aa',
            data: {
              nick: 'Angel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T15:20:00': {
          '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7': {
            createdAt: 1744039215491,
            activityId: '6436d36f5805e3b9c8c6ae803fa14f18a5cbbe522691ca28f22b2721273836b7',
            data: {
              nick: 'fuke your mom Angel',
              type: ActivityType.NewPlayer,
            },
          },
          '92eb521f7af6538b75b85872adaf9391f11087fc0038a4872cfb1bec7dc02468': {
            createdAt: 1744039254772,
            activityId: '92eb521f7af6538b75b85872adaf9391f11087fc0038a4872cfb1bec7dc02468',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'PazZayy',
              loserScore: 500,
              loserUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Gizmodeuss',
              winnerScore: 1810,
              winnerUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
            },
          },
          bdc15e732cf9efdf65245b7483c30e92d96b7a84df28a9e71375e9baf85057ad: {
            createdAt: 1744039223391,
            activityId: 'bdc15e732cf9efdf65245b7483c30e92d96b7a84df28a9e71375e9baf85057ad',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1520,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'PazZayy',
              winnerScore: 1910,
              winnerUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
            },
          },
        },
        '2025-04-07T15:23:00': {
          a4fffb2ab7136f3ea21b3167382e67bc78c62f488d483401c20828a70b3c2877: {
            createdAt: 1744039419403,
            activityId: 'a4fffb2ab7136f3ea21b3167382e67bc78c62f488d483401c20828a70b3c2877',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Fajar Fajar',
              loserScore: 1240,
              loserUserId: '3844092f-5a11-437a-be48-1d37079dbb83',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Gizmodeuss',
              winnerScore: 2900,
              winnerUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
            },
          },
        },
        '2025-04-07T15:27:00': {
          fea0457cf0b4ac93243b002e9c79041cf2c70f5ce6913061ea4630b9503b369c: {
            createdAt: 1744039624556,
            activityId: 'fea0457cf0b4ac93243b002e9c79041cf2c70f5ce6913061ea4630b9503b369c',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 1037,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'bettorbrady',
              winnerScore: 3990,
              winnerUserId: 'b9f06089-a3e0-4507-a937-5f314ac1ae70',
            },
          },
        },
        '2025-04-07T15:28:00': {
          '674efc7aa75366616d74c26d2d42aa92386faec32b82784ed62451c9ebb38fe5': {
            createdAt: 1744039738492,
            activityId: '674efc7aa75366616d74c26d2d42aa92386faec32b82784ed62451c9ebb38fe5',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 1548,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 2050,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          c0fccdf9459f285d25f0768799b881982ee7b62385350f647b08cf3a1491f975: {
            createdAt: 1744039730542,
            activityId: 'c0fccdf9459f285d25f0768799b881982ee7b62385350f647b08cf3a1491f975',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'bettorbrady',
              loserScore: 0,
              loserUserId: 'b9f06089-a3e0-4507-a937-5f314ac1ae70',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 20,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T15:31:00': {
          b7c7839bce4be2dc66adfdf8dffa361221266d8d63d68aea5b24cdd38044698b: {
            createdAt: 1744039862584,
            activityId: 'b7c7839bce4be2dc66adfdf8dffa361221266d8d63d68aea5b24cdd38044698b',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'bettorbrady',
              loserScore: 0,
              loserUserId: 'b9f06089-a3e0-4507-a937-5f314ac1ae70',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 505,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T15:32:00': {
          be14afb1ec63bc91cfb4b36140c369deeba1046e231fe1f02d07db3cd714ab72: {
            createdAt: 1744039954584,
            activityId: 'be14afb1ec63bc91cfb4b36140c369deeba1046e231fe1f02d07db3cd714ab72',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'la mera verga',
              loserScore: 400,
              loserUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1250,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T15:36:00': {
          e4eec30789e9191b8a4a1fe7b884be8cd47d9bb270b55ce83a1162168c5d02eb: {
            createdAt: 1744040163605,
            activityId: 'e4eec30789e9191b8a4a1fe7b884be8cd47d9bb270b55ce83a1162168c5d02eb',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 1238,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Gizmodeuss',
              winnerScore: 2620,
              winnerUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
            },
          },
        },
        '2025-04-07T15:37:00': {
          '7fceb0b8d8e2c8f1f0d70de851e665017d3622fa845856e124722b79349c3c70': {
            createdAt: 1744040257048,
            activityId: '7fceb0b8d8e2c8f1f0d70de851e665017d3622fa845856e124722b79349c3c70',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 350,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 800,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T15:40:00': {
          '17463db9fa6fdb0fb8ed882e261418d12ea51aae17bee6cbc27c1f7e8682db56': {
            createdAt: 1744040455193,
            activityId: '17463db9fa6fdb0fb8ed882e261418d12ea51aae17bee6cbc27c1f7e8682db56',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 260,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Semsudin Dizdarevic',
              winnerScore: 2000,
              winnerUserId: 'b1902607-2c3f-4900-8ec9-67ef183a35f5',
            },
          },
        },
        '2025-04-07T15:41:00': {
          c02b5fdbddcfc04ae719687df907f87cf3e5fee5c136448ed65cec51b7903269: {
            createdAt: 1744040483133,
            activityId: 'c02b5fdbddcfc04ae719687df907f87cf3e5fee5c136448ed65cec51b7903269',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 72,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 400,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T15:48:00': {
          '1f8db209c52bae37ea4e335f1c85582d6acc8b47110265c8f8d078deecc76ee2': {
            createdAt: 1744040919477,
            activityId: '1f8db209c52bae37ea4e335f1c85582d6acc8b47110265c8f8d078deecc76ee2',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'duboybrown',
              loserScore: 870,
              loserUserId: 'hwYTg9qMEQcUMCv8HUaMZ0EIOTe2',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'Lil Bro',
              winnerScore: 1700,
              winnerUserId: '5f1d4434-1ad0-47a8-87bc-a852edbc6510',
            },
          },
        },
        '2025-04-07T15:50:00': {
          '771cbde29b4fec6ce73e47a71a5293210f0c68b37efa97285745fd39187db08a': {
            createdAt: 1744041040759,
            activityId: '771cbde29b4fec6ce73e47a71a5293210f0c68b37efa97285745fd39187db08a',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'bettorbrady',
              loserScore: 40,
              loserUserId: 'b9f06089-a3e0-4507-a937-5f314ac1ae70',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 810,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T15:53:00': {
          '85f738bf4a6d308c347f1acefbb8793da10fe2571f18e445341f484cc49719b8': {
            createdAt: 1744041233260,
            activityId: '85f738bf4a6d308c347f1acefbb8793da10fe2571f18e445341f484cc49719b8',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Ishmael Watkins',
              loserScore: 300,
              loserUserId: '6e403e03-db95-4617-84a3-c8fa38a9ecc9',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: '1ll',
              winnerScore: 1000,
              winnerUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
            },
          },
          bf2e36676ab1d706e74f94cd6b8498d5c786dcdfe00ef8d5f0051626c6fa2e78: {
            createdAt: 1744041218751,
            activityId: 'bf2e36676ab1d706e74f94cd6b8498d5c786dcdfe00ef8d5f0051626c6fa2e78',
            data: {
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 2715,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 3255,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T15:57:00': {
          '6393daf9a919873b3217f90d0966d681dcf8df06cdfc3c969a4892bbe8a2e601': {
            createdAt: 1744041475308,
            activityId: '6393daf9a919873b3217f90d0966d681dcf8df06cdfc3c969a4892bbe8a2e601',
            data: {
              bounty: {
                amount: 20000,
                jackpot: true,
              },
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 1000,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$200.00',
              type: ActivityType.Win,
              winnerNick: 'ww815',
              winnerScore: 1140,
              winnerUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
            },
          },
        },
        '2025-04-07T16:01:00': {
          '9e76ae86d109cdfe0c84d06865cbb2b981464f33aeae46a79ef13e7af4ea0246': {
            createdAt: 1744041707931,
            activityId: '9e76ae86d109cdfe0c84d06865cbb2b981464f33aeae46a79ef13e7af4ea0246',
            data: {
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 400,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'la mera verga',
              winnerScore: 1100,
              winnerUserId: 'ZP1PfEawyDcVCtIwqCFuGuFmP1U2',
            },
          },
        },
        '2025-04-07T16:06:00': {
          d4893ab3f9e32f6cf01d09fdc9cf712b8bff4d671e54796ef9b81b6c8d1e44b7: {
            createdAt: 1744042016441,
            activityId: 'd4893ab3f9e32f6cf01d09fdc9cf712b8bff4d671e54796ef9b81b6c8d1e44b7',
            data: {
              firstPlayerNick: 'Jeramie Ayala',
              firstPlayerUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              gameId: GameId.Blackjack,
              reward: '$2.00',
              score: 0,
              secondPlayerNick: 'ChickieDee',
              secondPlayerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              type: ActivityType.Draw,
            },
          },
        },
        '2025-04-07T16:07:00': {
          '78b11c620f3062aff505098950a64aca32ba2191c69f2b25f651f8f620b83b9c': {
            createdAt: 1744042075477,
            activityId: '78b11c620f3062aff505098950a64aca32ba2191c69f2b25f651f8f620b83b9c',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Semsudin Dizdarevic',
              loserScore: 0,
              loserUserId: 'b1902607-2c3f-4900-8ec9-67ef183a35f5',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'ChickieDee',
              winnerScore: 800,
              winnerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
            },
          },
        },
        '2025-04-07T16:09:00': {
          '328ad4043cd5798193e503821759cee79b8c17ef4684e157509c2fd51e0920a4': {
            createdAt: 1744042162883,
            activityId: '328ad4043cd5798193e503821759cee79b8c17ef4684e157509c2fd51e0920a4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'ww815',
              loserScore: 100,
              loserUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 210,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          '870a96a1b4d12d12ac74e3e5411503df40e3d0c1fa1cfabd02b89099382bb913': {
            createdAt: 1744042169094,
            activityId: '870a96a1b4d12d12ac74e3e5411503df40e3d0c1fa1cfabd02b89099382bb913',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Woo',
              loserScore: 990,
              loserUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: '1ll',
              winnerScore: 1100,
              winnerUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
            },
          },
        },
        '2025-04-07T16:11:00': {
          '73f0d6f751738df8a8f33d19428819e0ebcabfb0467b8f1a7e193381d9814c14': {
            createdAt: 1744042278775,
            activityId: '73f0d6f751738df8a8f33d19428819e0ebcabfb0467b8f1a7e193381d9814c14',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 20,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'adrian1023',
              winnerScore: 820,
              winnerUserId: 'bb66bc33-78b5-48a4-88c6-486bb1148a34',
            },
          },
        },
        '2025-04-07T16:12:00': {
          '70d2063707ac1ade43e4c689cf36d63e99036439f33c2400d606cde559a9032e': {
            createdAt: 1744042364116,
            activityId: '70d2063707ac1ade43e4c689cf36d63e99036439f33c2400d606cde559a9032e',
            data: {
              firstPlayerNick: 'Jeramie Ayala',
              firstPlayerUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              gameId: GameId.Blackjack,
              reward: '$1.00',
              score: 0,
              secondPlayerNick: 'ww815',
              secondPlayerUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
              type: ActivityType.Draw,
            },
          },
          b46844bf32dbfc1fc585300b22e1a3bc4f7879c549f15a98465399bb4dea0b64: {
            createdAt: 1744042326351,
            activityId: 'b46844bf32dbfc1fc585300b22e1a3bc4f7879c549f15a98465399bb4dea0b64',
            data: {
              bounty: {
                amount: 100,
                jackpot: false,
              },
              gameId: GameId.Blackjack,
              loserNick: 'ww815',
              loserScore: 100,
              loserUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
              reward: '$5.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1412,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T16:15:00': {
          '8dbf0cd56b7f81a835cd222167209f6aeb6ca4b42dc0efa0d504a1da70ca5c44': {
            createdAt: 1744042501232,
            activityId: '8dbf0cd56b7f81a835cd222167209f6aeb6ca4b42dc0efa0d504a1da70ca5c44',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'ww815',
              loserScore: 3488,
              loserUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 12120,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
          a6ae18c396093c92bd2066d992e8e2dc0c7c3179388b29da3c26c0992461c1ad: {
            createdAt: 1744042505138,
            activityId: 'a6ae18c396093c92bd2066d992e8e2dc0c7c3179388b29da3c26c0992461c1ad',
            data: {
              firstPlayerNick: 'Jeramie Ayala',
              firstPlayerUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              gameId: GameId.Blackjack,
              reward: '$0.50',
              score: 0,
              secondPlayerNick: 'Omar Kaakour',
              secondPlayerUserId: 'ae530488-8cf5-4939-96a2-519803397d9d',
              type: ActivityType.Draw,
            },
          },
        },
        '2025-04-07T16:16:00': {
          c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be: {
            createdAt: 1744042572569,
            activityId: 'c470bd1c61abbe661992e4a336e1b2a010393a357847d9f9fcac131f940a71be',
            data: {
              nick: 'Ma Bloq',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:20:00': {
          a8c42e584c2247251c201e8eee40425223915c0a70cf8d5a46e6115ed4fc80a5: {
            createdAt: 1744042819443,
            activityId: 'a8c42e584c2247251c201e8eee40425223915c0a70cf8d5a46e6115ed4fc80a5',
            data: {
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 1500,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 2209,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
          cd05d846b483b2010b481ff2ae70096f4f9da55286c9ccbd0884023b2692222b: {
            createdAt: 1744042838628,
            activityId: 'cd05d846b483b2010b481ff2ae70096f4f9da55286c9ccbd0884023b2692222b',
            data: {
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 560,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1190,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T16:24:00': {
          '6f1f168037813e576d954f16eb42729b77f9961badf08b7004593622f7346ecd': {
            createdAt: 1744043085004,
            activityId: '6f1f168037813e576d954f16eb42729b77f9961badf08b7004593622f7346ecd',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'godneverdie',
              loserScore: 800,
              loserUserId: 'ZkoCf7kXVDfowrts5pSLfjNCVFr2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: '1ll',
              winnerScore: 1000,
              winnerUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
            },
          },
        },
        '2025-04-07T16:28:00': {
          '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d': {
            createdAt: 1744043321475,
            activityId: '220bdb59d8fec7d2a5ac61d37b9040fbb7d7458d27020352cd2acd252a1bbd3d',
            data: {
              nick: 'Loser',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:32:00': {
          '6f5b0dde77aa176f4b02aeb4feb4f67d523bae73ae801b04d429d0f32f63b7d4': {
            createdAt: 1744043551254,
            activityId: '6f5b0dde77aa176f4b02aeb4feb4f67d523bae73ae801b04d429d0f32f63b7d4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Omar Soto',
              loserScore: 1500,
              loserUserId: '0be13c53-5246-49ea-bd76-6b19ecfbadc4',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 1650,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T16:33:00': {
          '9778a5953f53b223a662d1429bfd0e4f3bf306640e4e0ea797ca10168b926782': {
            createdAt: 1744043614814,
            activityId: '9778a5953f53b223a662d1429bfd0e4f3bf306640e4e0ea797ca10168b926782',
            data: {
              gameId: GameId.Blackjack,
              loserNick: '1ll',
              loserScore: 205,
              loserUserId: 'DuTSHjO8XrZBLxkoPt6v6x6Xp9n1',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'Lil Bro',
              winnerScore: 2000,
              winnerUserId: '5f1d4434-1ad0-47a8-87bc-a852edbc6510',
            },
          },
        },
        '2025-04-07T16:45:00': {
          '982865cba7c9f59655de28162e868cc046de4cec6f6e99de94512eb2a699f009': {
            createdAt: 1744044304860,
            activityId: '982865cba7c9f59655de28162e868cc046de4cec6f6e99de94512eb2a699f009',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Roy Fister',
              loserScore: 762,
              loserUserId: 'ae4f2434-0dfe-4f2e-ab46-d5ea6b79e9f6',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Omar Kaakour',
              winnerScore: 1851,
              winnerUserId: 'ae530488-8cf5-4939-96a2-519803397d9d',
            },
          },
        },
        '2025-04-07T16:46:00': {
          '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad': {
            createdAt: 1744044363811,
            activityId: '04c3968592b847eaa32523de26a1af2b0bb5317a57d086d1ca7c0f6c1f0687ad',
            data: {
              nick: 'Joining Soon',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:51:00': {
          '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0': {
            createdAt: 1744044683325,
            activityId: '407b3eaf9ddc9c79305f8e6827e5e00421e9907e90a3f9d4b258384d69602ef0',
            data: {
              nick: 'Colapinto',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T16:54:00': {
          '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa': {
            createdAt: 1744044888736,
            activityId: '309636b9bc55a57778ce3a31863f6aefa065e6a334f95c758a304944a601feaa',
            data: {
              nick: 'Saturno',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:03:00': {
          '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559': {
            createdAt: 1744045401226,
            activityId: '84f6f6f0dc5ac217c13cc489ed67ef7eba32e048b9baf69408a84f724a6cf559',
            data: {
              nick: 'bostero topu',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:08:00': {
          '0bb306065ca32ee21f540c4a5d9c1c06ce568784ecbac4e6cc2989158fe25aff': {
            createdAt: 1744045724598,
            activityId: '0bb306065ca32ee21f540c4a5d9c1c06ce568784ecbac4e6cc2989158fe25aff',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'ferrari16',
              loserScore: 520,
              loserUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
              reward: '$200.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1030,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T17:15:00': {
          '7fc4ac999c21ce0111edc830eee57f62100fc28ef711b0977a3e5a8d24a4a57c': {
            createdAt: 1744046135492,
            activityId: '7fc4ac999c21ce0111edc830eee57f62100fc28ef711b0977a3e5a8d24a4a57c',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'ChickieDee',
              loserScore: 280,
              loserUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 1000,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T17:19:00': {
          f5e6c56078adc85678611c21634a469616c8eecc676fc3b6184986d66cdc9815: {
            createdAt: 1744046374607,
            activityId: 'f5e6c56078adc85678611c21634a469616c8eecc676fc3b6184986d66cdc9815',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'colloid',
              loserScore: 530,
              loserUserId: 'f3b26a98-cd9d-4541-8308-804109a59c27',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 630,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T17:26:00': {
          ba18fe6635d081462f9e838205a2e9325538e135e3aa940215d35c6334407e86: {
            createdAt: 1744046790159,
            activityId: 'ba18fe6635d081462f9e838205a2e9325538e135e3aa940215d35c6334407e86',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Bunker',
              loserScore: 1500,
              loserUserId: 'Ztj1gSWYbffo0PR8SC4HRCXb4au2',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Joseph Joseph',
              winnerScore: 2050,
              winnerUserId: '8815e28f-6be4-437b-9ec3-234e4a5a4421',
            },
          },
        },
        '2025-04-07T17:28:00': {
          '82439eac9441b1116cb8b1857f3dc93aabbb9ae71acf07f1ca6d62c8e5b27824': {
            createdAt: 1744046916370,
            activityId: '82439eac9441b1116cb8b1857f3dc93aabbb9ae71acf07f1ca6d62c8e5b27824',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Jeramie Ayala',
              loserScore: 0,
              loserUserId: 'fd8a2990-e6ea-41ef-8d59-007076313078',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'ChickieDee',
              winnerScore: 1280,
              winnerUserId: '46PjSe8BRbUKqhUFefslwGWDTzI2',
            },
          },
        },
        '2025-04-07T17:29:00': {
          b3dfaedf2ade6d0ef0b251d77e41590ac27e47d96dcbdaeeee549aa7802bf418: {
            createdAt: 1744046977666,
            activityId: 'b3dfaedf2ade6d0ef0b251d77e41590ac27e47d96dcbdaeeee549aa7802bf418',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'colloid',
              loserScore: 110,
              loserUserId: 'f3b26a98-cd9d-4541-8308-804109a59c27',
              reward: '$200.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 370,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T17:36:00': {
          '85822010a788fae75f6cd2e607ae534a33bcd8fdabf6075f3d2f37861d4f25b7': {
            createdAt: 1744047392078,
            activityId: '85822010a788fae75f6cd2e607ae534a33bcd8fdabf6075f3d2f37861d4f25b7',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 500,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Kristen Mahan',
              winnerScore: 1270,
              winnerUserId: '45d3d94b-6d2c-48a3-964a-ce4425731c4b',
            },
          },
        },
        '2025-04-07T17:37:00': {
          '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db': {
            createdAt: 1744047464940,
            activityId: '361b8edb90bf21dcd42d0fee3174e2539a58b93b7a89cd6d2f45697e6eb3a4db',
            data: {
              nick: 'Hakan Temel',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T17:50:00': {
          a2e499e2259f8f1c7bdf2991f6aee6d44dbcab3f24266090ca3aa403e6334f3c: {
            createdAt: 1744048213990,
            activityId: 'a2e499e2259f8f1c7bdf2991f6aee6d44dbcab3f24266090ca3aa403e6334f3c',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'tiffany wade',
              loserScore: 1055,
              loserUserId: 'fcd95fd7-c7a7-464e-83b5-ea3eae6342c5',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 2968,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T17:52:00': {
          e85ecbe62606e4b3699c5f7666a5999d5ede2eb30368b42f2c28ae77baa41376: {
            createdAt: 1744048362179,
            activityId: 'e85ecbe62606e4b3699c5f7666a5999d5ede2eb30368b42f2c28ae77baa41376',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 950,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 3042,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T17:54:00': {
          '412c2b9805721d431875c002add16c5a95418a9cea633b10f5fa6844d6d64f02': {
            createdAt: 1744048452074,
            activityId: '412c2b9805721d431875c002add16c5a95418a9cea633b10f5fa6844d6d64f02',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'jackwick2',
              loserScore: 950,
              loserUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'Cryptonator',
              winnerScore: 1070,
              winnerUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
            },
          },
        },
        '2025-04-07T17:57:00': {
          '088006d29a1b9e04d409b4f36d256b2c8e38a0e61df6dddc5801da6dfc1c6658': {
            createdAt: 1744048666608,
            activityId: '088006d29a1b9e04d409b4f36d256b2c8e38a0e61df6dddc5801da6dfc1c6658',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 2890,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wso18',
              winnerScore: 8260,
              winnerUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
            },
          },
        },
        '2025-04-07T18:00:00': {
          '16c5894c0ab1f96471fba99cbb23b2731275f8d965e7015bb784e3bf3429c6d2': {
            createdAt: 1744048829758,
            activityId: '16c5894c0ab1f96471fba99cbb23b2731275f8d965e7015bb784e3bf3429c6d2',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 1600,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'lokhin',
              winnerScore: 2500,
              winnerUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
            },
          },
        },
        '2025-04-07T18:03:00': {
          '05ce393db5a6bff15932e605d2163b7a0e0f528eb4c63eadbda2402839a84de4': {
            createdAt: 1744048982163,
            activityId: '05ce393db5a6bff15932e605d2163b7a0e0f528eb4c63eadbda2402839a84de4',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'lokhin',
              loserScore: 1200,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wso18',
              winnerScore: 1300,
              winnerUserId: 'meK5vW1SDdUv5ZK7idQyWHqXYKR2',
            },
          },
        },
        '2025-04-07T18:04:00': {
          '7f6a01cccf3311f7d17f38465ef3355df5f87ea46903b5a865866299b6d1cd43': {
            createdAt: 1744049081658,
            activityId: '7f6a01cccf3311f7d17f38465ef3355df5f87ea46903b5a865866299b6d1cd43',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 0,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 1350,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T18:05:00': {
          '0b0ade8abe1ab000279b5416feb316cf544fb4d63473211c9b84eb84b0982a18': {
            createdAt: 1744049103006,
            activityId: '0b0ade8abe1ab000279b5416feb316cf544fb4d63473211c9b84eb84b0982a18',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 0,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wizard0777',
              winnerScore: 1200,
              winnerUserId: '1Xlc0x05PUXJZjfJ80gjk0kEKuH2',
            },
          },
        },
        '2025-04-07T18:10:00': {
          '1e7cfce42a13e57ebfab990fd8ddfe3f6ae4f713a1aefa18ea0ce8baba219eb8': {
            createdAt: 1744049458796,
            activityId: '1e7cfce42a13e57ebfab990fd8ddfe3f6ae4f713a1aefa18ea0ce8baba219eb8',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Jason Brice',
              loserScore: 0,
              loserUserId: '3effefc6-af46-4227-8a4d-595303df03f3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'wizard0777',
              winnerScore: 450,
              winnerUserId: '1Xlc0x05PUXJZjfJ80gjk0kEKuH2',
            },
          },
        },
        '2025-04-07T18:12:00': {
          f1c282b7ff769fa78a0ed05367940c65029c457755a6785536a2b71a7788b860: {
            createdAt: 1744049545023,
            activityId: 'f1c282b7ff769fa78a0ed05367940c65029c457755a6785536a2b71a7788b860',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'lokhin',
              loserScore: 0,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Cryptonator',
              winnerScore: 900,
              winnerUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
            },
          },
        },
        '2025-04-07T18:15:00': {
          f4fb487c44cb3765fb955da0087ac5273f0539a5332c6257a69fffb9ab5a4593: {
            createdAt: 1744049718347,
            activityId: 'f4fb487c44cb3765fb955da0087ac5273f0539a5332c6257a69fffb9ab5a4593',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'lokhin',
              loserScore: 0,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'jgprimex',
              winnerScore: 1000,
              winnerUserId: 'de63fa70-7b77-4a7e-ae3a-46a9a9d999a8',
            },
          },
        },
        '2025-04-07T18:16:00': {
          '3023fe92b965ca04c6a6ba253995d5b23bfa87d089c922829ef74b4243706905': {
            createdAt: 1744049812963,
            activityId: '3023fe92b965ca04c6a6ba253995d5b23bfa87d089c922829ef74b4243706905',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Christopher Tyrer',
              loserScore: 150,
              loserUserId: 'a71743fd-8dd5-4547-b82f-a0b6718e7a82',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Cryptonator',
              winnerScore: 400,
              winnerUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
            },
          },
        },
        '2025-04-07T18:19:00': {
          ceec9ad51bd3ae133d66a80eaec7907123c38689a78d5a8c818e6916ad841707: {
            createdAt: 1744049955299,
            activityId: 'ceec9ad51bd3ae133d66a80eaec7907123c38689a78d5a8c818e6916ad841707',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'lokhin',
              loserScore: 1100,
              loserUserId: 'e64552b3-a547-46f3-9f03-d2dba5bac5d4',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Gizmodeuss',
              winnerScore: 1500,
              winnerUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
            },
          },
        },
        '2025-04-07T18:21:00': {
          f098c3b9ca2d88e38505e73dd2a635172283211cb547efe01be4d1913c16c25b: {
            createdAt: 1744050083577,
            activityId: 'f098c3b9ca2d88e38505e73dd2a635172283211cb547efe01be4d1913c16c25b',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Jason Brice',
              loserScore: 0,
              loserUserId: '3effefc6-af46-4227-8a4d-595303df03f3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Cryptonator',
              winnerScore: 1100,
              winnerUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
            },
          },
        },
        '2025-04-07T18:22:00': {
          d49fb4810c98715da14deb21bfebaf0cbd145fd63dd5b5891ac589664c65cf54: {
            createdAt: 1744050133753,
            activityId: 'd49fb4810c98715da14deb21bfebaf0cbd145fd63dd5b5891ac589664c65cf54',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 0,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Christopher Tyrer',
              winnerScore: 50,
              winnerUserId: 'a71743fd-8dd5-4547-b82f-a0b6718e7a82',
            },
          },
        },
        '2025-04-07T18:27:00': {
          '5cc1399829664a4960313fcd5ca96e1944052be2065e04a7dfd28ae47598ba17': {
            createdAt: 1744050420929,
            activityId: '5cc1399829664a4960313fcd5ca96e1944052be2065e04a7dfd28ae47598ba17',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'deathpunch361',
              loserScore: 20,
              loserUserId: 'd3c7e34c-dcff-4953-9768-e363d4a7b994',
              reward: '$50.00',
              type: ActivityType.Win,
              winnerNick: 'ww815',
              winnerScore: 2300,
              winnerUserId: '7iy1eIPdxxZkmVFi9IcNsIXUc3x1',
            },
          },
        },
        '2025-04-07T18:28:00': {
          f23f717c14faaab063083ad1b571d39fd812242d7a81ef05073691622ee34faa: {
            createdAt: 1744050493046,
            activityId: 'f23f717c14faaab063083ad1b571d39fd812242d7a81ef05073691622ee34faa',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Ramon Rodriguez',
              loserScore: 550,
              loserUserId: '47306d54-67f4-4e50-adbb-0a0aea54f44d',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'PazZayy',
              winnerScore: 840,
              winnerUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
            },
          },
        },
        '2025-04-07T18:30:00': {
          '4de95603a9f1011693bd3508b158f7ad5355826aeaa50f61d095935ecba429da': {
            createdAt: 1744050643546,
            activityId: '4de95603a9f1011693bd3508b158f7ad5355826aeaa50f61d095935ecba429da',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'PazZayy',
              loserScore: 1240,
              loserUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
              reward: '$2.00',
              type: ActivityType.Win,
              winnerNick: 'ferrari16',
              winnerScore: 2900,
              winnerUserId: 'ceca90a3-6ac2-476b-b5f5-8aadf250a220',
            },
          },
        },
        '2025-04-07T18:32:00': {
          '710fe5cb17ffcb754b8737182e5f47bae24a6a491c010a5858fe8c292fd13964': {
            createdAt: 1744050729544,
            activityId: '710fe5cb17ffcb754b8737182e5f47bae24a6a491c010a5858fe8c292fd13964',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'PazZayy',
              loserScore: 600,
              loserUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
              reward: '$10.00',
              type: ActivityType.Win,
              winnerNick: 'Hammer_hard',
              winnerScore: 1605,
              winnerUserId: '8e382345-5569-46f3-92e8-0e3c678b1b13',
            },
          },
        },
        '2025-04-07T18:35:00': {
          '59bef7f209f59113d831ff16f0f54c51b9e2ba87383affd973c37dc5abad17d0': {
            createdAt: 1744050952193,
            activityId: '59bef7f209f59113d831ff16f0f54c51b9e2ba87383affd973c37dc5abad17d0',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Cryptonator',
              loserScore: 1120,
              loserUserId: 'BG91lF38izThS1eBJ0kklLeCmeI3',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'PazZayy',
              winnerScore: 1990,
              winnerUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
            },
          },
          '8b76d80c0dd20a8df2a48e37a0615eb86bd02b2ee051550f0426325a4f32b514': {
            createdAt: 1744050916061,
            activityId: '8b76d80c0dd20a8df2a48e37a0615eb86bd02b2ee051550f0426325a4f32b514',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 25,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Cory Bishop',
              winnerScore: 1400,
              winnerUserId: '81c7e964-8cfd-417c-8c1d-1a913464302a',
            },
          },
        },
        '2025-04-07T18:41:00': {
          b9a4fae1c576165eda9c47bb14c09046e1d1c6030b9c92afb82ab1cd9e00689d: {
            createdAt: 1744051284413,
            activityId: 'b9a4fae1c576165eda9c47bb14c09046e1d1c6030b9c92afb82ab1cd9e00689d',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 0,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'PrestonsGirl ',
              winnerScore: 500,
              winnerUserId: 'DDvKjZX7HJcwzoE5pg3NfjAERIv1',
            },
          },
        },
        '2025-04-07T18:42:00': {
          '4e0d1c141f8532bc6b005bbba46eed0ff01c5fd04b4b2d995a9f5ab2575d577a': {
            createdAt: 1744051378055,
            activityId: '4e0d1c141f8532bc6b005bbba46eed0ff01c5fd04b4b2d995a9f5ab2575d577a',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'PazZayy',
              loserScore: 340,
              loserUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Ashley Wilson',
              winnerScore: 1390,
              winnerUserId: 'ffe2bb90-09c7-457b-ae05-a41cd3d4f167',
            },
          },
        },
        '2025-04-07T18:45:00': {
          a66ba0455c06e5d560fd67473100beb65b26636453ebc786b06e04d3bf154b3d: {
            createdAt: 1744051535848,
            activityId: 'a66ba0455c06e5d560fd67473100beb65b26636453ebc786b06e04d3bf154b3d',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'Gizmodeuss',
              loserScore: 0,
              loserUserId: 'f0b8afcc-3795-4b49-8248-8d80f0c9a72d',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'Woo',
              winnerScore: 1433,
              winnerUserId: '0ANFbHbkKXgv2ss6NJ1oLB5jxli2',
            },
          },
        },
        '2025-04-07T18:50:00': {
          dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b: {
            createdAt: 1744051836883,
            activityId: 'dec1e2363e25129cb8776e4462b7cfb8c2fb4f6be4f8c1425c77cd0af36c533b',
            data: {
              nick: 'Schneider',
              type: ActivityType.NewPlayer,
            },
          },
        },
        '2025-04-07T18:51:00': {
          '9836d7c8c4b63e1770d60d96cfa71756930cfc838b15f75e71310131167c86d8': {
            createdAt: 1744051893674,
            activityId: '9836d7c8c4b63e1770d60d96cfa71756930cfc838b15f75e71310131167c86d8',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'takumar',
              loserScore: 0,
              loserUserId: '536f560c-ef50-4c9d-930a-30832a52f5e4',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 10,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T18:52:00': {
          '14eb8e05ddac2c41c79368410897b8ddc46d08205570c790ca9a586438bbeeaf': {
            createdAt: 1744051968887,
            activityId: '14eb8e05ddac2c41c79368410897b8ddc46d08205570c790ca9a586438bbeeaf',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'bitcoinm0',
              loserScore: 0,
              loserUserId: 'yWGs0WTyGgTLrAwgHEkyRrEKphM2',
              reward: '$1.00',
              type: ActivityType.Win,
              winnerNick: 'PazZayy',
              winnerScore: 1650,
              winnerUserId: '3250050e-ad3a-4d06-b779-bcc1b532dfe0',
            },
          },
          '30127faa4ec0798402cf23626d520b641a1edc3789ffe508f454e62f640f96d0': {
            createdAt: 1744051958561,
            activityId: '30127faa4ec0798402cf23626d520b641a1edc3789ffe508f454e62f640f96d0',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'takumar',
              loserScore: 1640,
              loserUserId: '536f560c-ef50-4c9d-930a-30832a52f5e4',
              reward: '$20.00',
              type: ActivityType.Win,
              winnerNick: 'jackwick2',
              winnerScore: 2150,
              winnerUserId: 'e1bc8acc-e1b1-4c79-ad6e-6967e90a0b65',
            },
          },
        },
        '2025-04-07T18:53:00': {
          '1e93bc118322c12fbdfe7d68c9bb9235445439c0c007a5ca3f644621514bf852': {
            createdAt: 1744052024832,
            activityId: '1e93bc118322c12fbdfe7d68c9bb9235445439c0c007a5ca3f644621514bf852',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'UrbanDoomLoop',
              loserScore: 1245,
              loserUserId: 'Qr6lHGeJGUdAjloWDRufG55sTTA3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Ashley Wilson',
              winnerScore: 1917,
              winnerUserId: 'ffe2bb90-09c7-457b-ae05-a41cd3d4f167',
            },
          },
          ae885073680c775b5da491339b43ae87f30e6c0e7daf60213ee498f6d4be2eff: {
            createdAt: 1744051995888,
            activityId: 'ae885073680c775b5da491339b43ae87f30e6c0e7daf60213ee498f6d4be2eff',
            data: {
              gameId: GameId.Blackjack,
              loserNick: 'UrbanDoomLoop',
              loserScore: 0,
              loserUserId: 'Qr6lHGeJGUdAjloWDRufG55sTTA3',
              reward: '$0.50',
              type: ActivityType.Win,
              winnerNick: 'Ashley Wilson',
              winnerScore: 1020,
              winnerUserId: 'ffe2bb90-09c7-457b-ae05-a41cd3d4f167',
            },
          },
        },
      },
    },
  },
};
